import { DatePipe } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MessageService, TreeNode } from 'primeng/api';
import { Table } from 'primeng/table';
import {
  ImageSources,
  LocalStorage,
  MenuItemsAccess,
} from 'src/app/appCommon/Enums/enum';
import { AnalyzeService } from 'src/app/appServices/AnalyzeService/analyzeService.service';
import { HelperService } from 'src/app/appServices/HelperService/helper.service';
import { ToasterService } from 'src/app/appServices/ToasterService/toaster.service';
import { TreeService } from 'src/app/appServices/treeSelectionService/treeService';
import * as $ from 'jquery';
import 'jstree';
import { Subscription } from 'rxjs';
import { timer } from 'rxjs';
import { environment } from 'src/environments/environment';
import { MeasureService } from 'src/app/appServices/MeasureService/measureService.service';
import { ObservableService } from 'src/app/appServices/ObservableService/observable.service';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditorComponent } from '@ckeditor/ckeditor5-angular';
import * as FileSaver from 'file-saver'; // FOR SAVING EXCEL FILE
import { Workbook } from 'exceljs';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
const htmlToPdfmake = require('html-to-pdfmake');
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import {
  audioOnlyList,
  cas_nihss_reasonOptions,
  caseTypeOptions,
  doortoNeedleTimeOptions,
  eAlertOptions,
  folowUpList,
  qpsReviewOptions,
  selectWorkFlowTypeOptions,
  statusList,
  thrombolyticComplicationDropdown,
  thrombolyticsOptions,
  timeFameList,
  typeOfCorrespondence,
} from 'src/app/appWeb/shared/shared';
import { AuthService } from 'src/app/appServices/AuthService/auth.service';
import { AccessControlService } from 'src/app/appServices/CommonService/access-control.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';
(<any>pdfMake).vfs = pdfFonts.pdfMake.vfs;
const domtoimage = require('dom-to-image');

@Component({
  selector: 'app-cases',
  templateUrl: './cases.component.html',
  styleUrls: ['./cases.component.scss'],
})
export class CasesComponent implements OnInit {
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' },
    ],
    customClasses: [
      {
        name: 'table',
        class: 'table',
        tag: 'table',
      },
    ],
    uploadWithCredentials: false,
    sanitize: false,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['fontName'],
      [
        'fontSize',
        'subscript',
        'superscript',
        'insertHorizontalRule',
        'removeFormat',
        'toggleEditorMode',
      ],
    ],
  };
  @ViewChild('dt') dt: Table | undefined;
  @ViewChild('dt') quarter: Table | undefined;
  FileSaver = FileSaver;
  editorr = ClassicEditor;
  @ViewChild('editor') editorComponent!: CKEditorComponent;
  cases: any = [];
  totalRecords = 0;
  pageNumber = 1;
  rows = 15;
  sortOrder = 'DESC';
  sortCol = '';
  filterVal = '';
  cols: any;
  showProgressSpinner: boolean = false;
  noRecordBool = false;
  EditScreenBool: boolean = false;
  CaseSelectedTab = 'Case Review';
  selectedFacility: any = [];
  facilityList: any = [];
  physicionList: any = [];
  selectedPhysicion: any = [];
  form!: FormGroup;
  advanceFormSearch!: FormGroup;
  historyBool: boolean = false;
  typeOfCorrespondence = typeOfCorrespondence;
  Correspondence: any;
  CorrespondenceForm: FormGroup;
  CounterMeasuresForm: FormGroup;
  MedicalDirectorForm: FormGroup;
  QPSReviewField: boolean = false;
  TFLABool: boolean = false;
  internalNotesBool: boolean = false;
  internalNotes = '';
  currentDate: any = '';
  currentDateFormate: any = '';
  currentTime: any;
  reviewCompletedBool: boolean = false;
  audioOnlyList = audioOnlyList;
  audioOnly = '';
  casIsFlaggedList = audioOnlyList;
  casIsFlagged = '';
  statusList = statusList;
  status: any = [];
  folowUpList = folowUpList;
  folowUp = '';
  editCaseData: any = '';
  case_leadership_review: any;
  qpsList: any;
  directorList: any;
  peerReviewPhysicians: any;
  leaderReviewingDropdown: any = [];
  listReviewersDropdown: any = [];
  directorListDropdown: any = [];
  peerReviewPhysicionDropdown: any = [];
  listReviewers: any;
  leaderReviewingObject: any = {};
  caseKey: number = 0;
  MDReviewCompletedString = '';
  MDReviewinitiatedString = '';
  dateAndTimeOfContactString = '';
  typeOfCorrespondenceString = '';
  commentsString = '';
  UName = '';
  disabled: boolean = true;
  HistoryData: any;
  tfla: any = '';
  Ealert = '';
  thrombolytic_used = '';
  EalertBool: boolean = false;
  OperationsReview: boolean = false;
  PhysicianName = '';
  workFlowType = '';
  ActivationTimeIntervalMetricBool: boolean = false;
  ThrombolyticAdministrationIntervalMetricBool: boolean = false;
  ThrombolyticDecisionIntervalMetricBool: boolean = false;
  AssessmentTimeIntervalMetricBool: boolean = false;
  firstTimeLoginAttemtToNIHSSassTimeBool: boolean = false;
  thrombolyticCandidateBool: boolean = false;
  thrombolyticComplicationBool: boolean = false;
  thrombolyticComplicationDropdown = thrombolyticComplicationDropdown;
  correspondenceBool: boolean = false;
  medicalDirectorBool: boolean = false;
  StartTimetoNeedleTimeLessThen40MinutesBool: boolean = false;
  TFLAtoNeedleTimelessThen30MinutesBool: boolean = false;
  ArrivalToNeedleTimeBool: boolean = false;
  casResponseMDToreviewBool: boolean = false;
  PeerReviewRequestedBool: boolean = false;
  formDataFinal: any;
  SelectedNodesText: any = [];
  MdDateEst: boolean = false;
  PreeAssignmentEst: boolean = false;
  PreeInitiatedEst: boolean = false;
  PreecompletedEst: boolean = false;
  QpsCompletedEst: boolean = false;
  OperationsCompletedEst: boolean = false;

  timeFrame = 'Last48Hours';
  searchField: any = '';
  txtStartDate: any = '';
  txtEndDate: any = '';
  txtSpecificDate: any = '';
  data = {};
  showStartEndDateBool: boolean = false;
  showDateBool: boolean = false;
  loading = [false, false, false, false];
  timeFameList = timeFameList;
  datePipe = new DatePipe('en-US');
  caseReviewTemplateButtonName: any = '';
  markActivation: boolean = false;
  markAssesment: boolean = false;
  markThrombolytic: boolean = false;
  markThrombolyticAdmin: boolean = false;
  RCADataForTemplate: any = [];
  /* tree selection */
  treeSelection!: TreeNode[];
  treeSelected: any[] = [];

  activationParentArray: any = [];
  assessmentParentArray: any = [];
  thrombolyticDecParentArray: any = [];
  thrombolyticAdmParentArray: any = [];

  selectedTree!: TreeNode;
  treeSelectionBool: boolean = false;
  treeLable = '';
  position = '';
  caseResponse: any;
  PatientType: any;
  cas_rcaDiagramOption = '';
  timeZone: string = '';
  cas_review_qps_reviewed_completed: any = '';
  cas_response_MD_assignment_datetime: any = '';
  cas_response_peer_review_assignment_stamp: any = '';
  cas_response_peer_review_initiated_stamp: any = '';
  cas_response_peer_review_completed_stamp: any = '';
  cas_response_operations_review_completed: any = '';
  ArrivalToNeedleTimeLable: any;
  errorMessageBool: boolean = false;
  timer: any;
  selectedTeleneuro_QPS: any = [];
  cas_case_type: any = [];

  /* Thrombolytic Administration Timeline */
  greens: string = '#19e366';
  yellows: string = '#e1ed00';
  reds: string = '#ed0000';
  workflowtypeForTimeline: string = '';
  tPACandidate: boolean = false;
  _startime: any;
  _logintime: any;
  _nihsstime: any;
  _needletime: any;
  dtnorstn: string = '';
  _arivaltime: any;
  _starttoarival: number = 0;
  _logintodoor: number = 0;
  _nihsstodoor: number = 0;
  _doortoneedle: number = 0;
  _arivaltovideoendtime: number = 0;
  _needletodoor: number = 0;
  _isCas_metric_symptom_onset_during_ed_stay: boolean = false;
  labeldiagram: string = '';
  labeldiagramstime: string = '';
  _lastknownwelltime: any = '';
  workflowlabel: string = '';
  knownweltimetostarttime: number = 0;
  knownweltimetologintime: number = 0;
  knownweltimetonihss: number = 0;
  knownweltimetoneedle: number = 0;
  event: any = '';
  counterMeasuresBool: boolean = false;
  i!: number;
  backToCasesListData: any;
  rootCauseIdsValue: any = [];
  rootCauseValue: any = [];
  counterMeasureValue: any = [];
  responsiblePartyValue: any = [];
  proposedDueDateValue: any = [];
  completedDateValue: any = [];
  convertedFromDate: any;
  convertedToDate: any;
  RCACountermeasuresByCase: any;
  unSelectArray: any = [];
  accessCase: string = '';
  viewCaseReview: any;
  isReadonly: boolean = false;
  /* ckEditor */
  directorListForTemplate: any = [];
  generateTemplatebool: boolean = false;
  caseStartTime: any;
  Temp_cas_metric_initial_response_time_est: any = '';
  Temp_ctai_nir_discussion_time: any = '';
  initial_response_time_to_Discussed_with_NIR_time: any;
  roleAccessResult: any = [];
  isAccessReadWrite: boolean = false;
  isAccessRead: boolean = false;
  teleUrl: string = environment.teleUrl;
  UId: any;
  RoleName: any;
  caseStatus: any;
  showSaveBool: boolean = false;
  ide: any;
  isAccessLeaderShipReview: boolean = false;
  isReadonlyUnCancleCase: boolean = false;
  caseHeaderName: any = '';
  isTemplateBool: boolean = true;
  cas_response_ts_notification_for_color: any = '';
  cas_metric_door_time_est: any = '';
  activation_circle_time: any = '';
  cas_metric_lastwell_date_est_for_color: any = '';
  cas_assessment_time_est_for_color: any = '';
  cas_metric_alteplase_medical_decision_for_color: any = '';
  cas_assessment_time_est_for_circle: any = '';
  Director_to_Review_bool!: boolean;
  txtStartDateErrorBool: boolean = false;
  txtEndDateErrorBool: boolean = false;
  txtSpecificDateErrorBool: boolean = false;
  textStrtColorBool: boolean = false;
  textEndColorBool: boolean = false;
  specificDatecolorBool: boolean = false;
  dateRangeBool: boolean = false;
  TATimelineBool: boolean = true;
  thrombolytic_decision_time: any = '';
  thrombolic_administration_circle_time: any = '';
  time_for_red_color_needle: any = '';
  arrival_time_before_circle: any = '';
  time_after_circle: any = '';
  beforeCircleBool: boolean = true;
  before_circle_bool: boolean = false;
  clearSearchBool: boolean = false;
  internalNotesSaveBool: boolean = true;
  isAccessInternalNotes: boolean = false;
  exportExcelLoader: boolean = false;
  excelBool: boolean = false;

  advanceSearchModal: boolean = false;
  Teleneuro_QPS: any = [];
  selectWorkFlowTypeOptions = selectWorkFlowTypeOptions;
  caseTypeOptions = caseTypeOptions;
  eAlertOptions = eAlertOptions;
  thrombolyticsOptions = thrombolyticsOptions;
  cas_nihss_reasonOptions = cas_nihss_reasonOptions;
  qpsReviewOptions = qpsReviewOptions;
  advanceSearchLoader: boolean = false;
  thrombolytics: any = [];
  qpsReviewCompleted: any = [];
  doortoNeedleTimeOptions = doortoNeedleTimeOptions;
  doortoNeedleTime: any = [];
  @ViewChild('myLink') myLink!: ElementRef;
  isAccessTFLA: boolean = false;
  isAccessPhysicionHistory: boolean = false;
  editScreen: boolean = false;
  sharedReportLoader: boolean = false;
  selectedFilterType: any;
  selectedOptionText: boolean = false;
  facilityMailData: any = [];
  noRecordFoundBool: boolean = false;
  displayBasic2: boolean = false;
  take: any = 10;
  skip: any = 0;
  showsharedProgressSpinner: boolean = false;
  facilityName: any;
  sharebtnLoader: boolean = false;
  selectFacilityPIOptions: any;
  shareImprove: any = [];
  displayModal: boolean = false;
  masterSelected: undefined;
  checkedList: any = [];
  reportPageBool: boolean = false;
  sendEmailLoader: boolean = false;
  private subscription: Subscription[] = [];
  SelectedCaseEdit: any = [];
  parentSelections: any = [];
  toolTip!: string;
  ArrivalToNeedleTimeBoolean: boolean = false;
  roleForFacility: boolean = false;
  labelAfterCircle: string = '';
  mainRCADiagramFCRT: boolean = false;
  caseDetail: any;
  showToast: boolean = false;
  minDate = new Date();
  crossSearchBool: boolean = false;
  cas_nihss_cannot_completedBool: boolean = false;
  cas_nihss_reasonBool: boolean = false;
  cas_nihss_totalscore: any;
  cas_NIHSS_comatose: any;

  constructor(
    private treeService: TreeService,
    public analyzeService: AnalyzeService,
    public fb: FormBuilder,
    private toastService: ToasterService,
    private helperService: HelperService,
    private messageService: MessageService,
    public measureService: MeasureService,
    private Observable: ObservableService,
    private router: Router,
    private route: ActivatedRoute,
    private toastrNotificaion: ToasterService,
    private authService: AuthService,
    private accessControlService: AccessControlService,
    private cdr: ChangeDetectorRef
  ) {
    this.CorrespondenceForm = this.fb.group({
      correspondenceRecord: this.fb.array([]),
    });
    this.MedicalDirectorForm = this.fb.group({
      MedicalDirectorReview: this.fb.array([]),
    });
    this.CounterMeasuresForm = this.fb.group({
      counterMeasuresRecord: this.fb.array([]),
    });
  }

  ngOnInit(): void {
    this.analyzeService._facilityPiComponent.CasesComponent = this;
    this.createForm();
    this.advanceSearchForm();
    this.UName = this.helperService.decryption(
      localStorage.getItem(LocalStorage.UName)
    );
    this.UId = this.helperService.decryption(
      localStorage.getItem(LocalStorage.UId)
    );
    this.RoleName = this.helperService.decryption(
      localStorage.getItem(LocalStorage.UserRoleName)
    );
    this.roleForFacility = this.authService.roleForFacility();
    this.minDate = this.analyzeService.CalanderDateRangeSelection(
      this.roleForFacility
    );
    this.subscription.push(
      this.route.queryParamMap.subscribe((params: any) => {
        if (Boolean(params.get('getCaseDetail'))) {
          const getCase = params.get('getCaseDetail');
          const getCaseDetail = Boolean(getCase);
          const edit = params.get('editScreen');
          this.editScreen = Boolean(edit);
          const caseKey = params.get('caseKey');
          const caseStatus = params.get('caseStatus');
          const caseStartTime = params.get('caseStartTime');
          const screenStatus = params.get('screenStatus');
          const SelectedCaseEdit = JSON.parse(params.get('SelectedCaseEdit'));
          const data = {
            CaseKey: caseKey,
            CaseStatus: caseStatus,
            CaseStartTime: caseStartTime,
            CASENumber: SelectedCaseEdit?.CASENumber,
            FacilityName: SelectedCaseEdit?.FacilityName,
          };
          if (getCaseDetail && screenStatus == 'Edit') {
            this.isReadonly = false;
            this.cases.push(SelectedCaseEdit);
            this.getCaseDetailByCaseId(data);
          } else if (getCaseDetail && screenStatus == 'View') {
            this.isReadonly = true;
            this.cases.push(SelectedCaseEdit);
            this.Viewcasereview(data);
          }
          if (this.editScreen) {
            this.EditScreenBool = true;
            this.CheckRoleAccess();
          }
          this.analyzeService.ClearQueryParams();
        }
      })
    );
    this.getAllFacility();
  }

  ngAfterContentInit(): void {
    if (!this.editScreen) {
      this.subscription.push(
        this.Observable.value$.subscribe((val) => {
          this.EditScreenBool = val;
          this.searchField = '';
        })
      );
    }
  }
  getAllFacility() {
    this.subscription.push(
      this.analyzeService.GetFacilityPIList(this.RoleName, this.UId).subscribe({
        next: (res: any) => {
          if (res) {
            this.facilityList = res?.Facilities;
            this.Teleneuro_QPS = res?.QPSList;
          }
        },
        error: (err: any) => {},
      })
    );
  }
  checkEmptyFields() {
    if (
      this.audioOnly == '' &&
      this.audioOnly == null &&
      this.folowUp == '' &&
      this.folowUp == null &&
      this.status == null &&
      this.timeFrame == '' &&
      this.timeFrame == null &&
      this.searchField == '' &&
      this.searchField == null &&
      this.txtSpecificDate == '' &&
      this.txtSpecificDate == null &&
      this.txtStartDate == '' &&
      this.txtStartDate == null &&
      this.txtEndDate == '' &&
      this.txtEndDate == null &&
      this.casIsFlagged == '' &&
      this.casIsFlagged == null &&
      this.selectedPhysicion == null &&
      this.selectedFacility == null
    ) {
      this.data = {
        Take: this.excelBool ? 0 : this.rows,
        Skip: this.excelBool ? 0 : this.rows * this.pageNumber - this.rows,
        Sort: {
          FieldName: this.sortCol,
          Order: this.sortOrder,
        },
        searchString: this.searchField.trim(),
        PageNumber: this.pageNumber,
        serviceType: [],
        roleIDs: [''],
        Filters: [],
      };
    } else {
      let advance_date: any;
      if (this.advanceFormSearch.controls['cas_advance_date'].value) {
        advance_date = this.datePipe.transform(
          this.advanceFormSearch.controls['cas_advance_date'].value,
          'MM/dd/yyyy'
        );
      }
      if (this.advanceFormSearch.controls['folowUp'].value != null) {
        if (this.advanceFormSearch.controls['folowUp'].value.length > 0) {
          this.folowUp = this.advanceFormSearch.controls['folowUp'].value[0];
        }
      }
      if (this.timeFrame === '-1') {
        this.txtEndDate = new Date().toDateString();
        this.txtStartDate = this.analyzeService
          .CalanderDateRangeSelection(this.roleForFacility)
          .toDateString();
      }
      this.data = {
        Take: this.excelBool ? 0 : this.rows,
        Skip: this.excelBool ? 0 : this.rows * this.pageNumber - this.rows,
        Sort: {
          FieldName: this.sortCol,
          Order: this.sortOrder,
        },
        searchString: this.searchField.trim(),
        PageNumber: this.pageNumber,
        serviceType: [],
        roleIDs: [''],
        Filters: [
          {
            FieldName: 'cas_is_audio_consult',
            value: this.audioOnly,
          },
          {
            FieldName: 'cas_is_flagged',
            value: this.casIsFlagged,
          },
          {
            FieldName: 'cas_status',
            value: this.status.toString(),
          },
          {
            FieldName: 'date_filter',
            value: this.timeFrame == '-1' ? 'DateRange' : this.timeFrame,
          },
          {
            FieldName: 'search_text',
            value: this.searchField.trim(),
          },
          {
            FieldName: 'specific_date',
            value: this.txtSpecificDate,
          },
          {
            FieldName: 'start_date',
            value: this.txtStartDate,
          },
          {
            FieldName: 'end_date',
            value: this.txtEndDate,
          },
          {
            FieldName: 'cas_case_number',
            value: this.advanceFormSearch.controls['cas_case_number'].value,
          },
          {
            FieldName: 'cas_case_type',
            value: this.cas_case_type ? this.cas_case_type.toString() : null,
          },
          {
            FieldName: 'cas_patient',
            value: this.advanceFormSearch.controls['cas_patient'].value,
          },
          {
            FieldName: 'cas_advance_date',
            value: advance_date,
          },
          {
            FieldName: 'facilityIDs',
            value: this.selectedFacility
              ? this.selectedFacility.toString()
              : null,
          },
          {
            FieldName: 'advance_cas_billing_visit_type',
            value: this.folowUp
              ? this.folowUp
              : this.advanceFormSearch.controls['folowUp'].value
              ? this.advanceFormSearch.controls['folowUp'].value.toString()
              : null,
          },
          {
            FieldName: 'CASEIdentificatinNumber',
            value:
              this.advanceFormSearch.controls['CASEIdentificatinNumber'].value,
          },
          {
            FieldName: 'physcianIDs',
            value: this.advanceFormSearch.controls['selectedPhysicion'].value
              ? this.advanceFormSearch.controls[
                  'selectedPhysicion'
                ].value.toString()
              : null,
          },
          {
            FieldName: 'cas_eAlert',
            value: this.advanceFormSearch.controls['cas_eAlert'].value
              ? this.advanceFormSearch.controls['cas_eAlert'].value.toString()
              : null,
          },
          {
            FieldName: 'ThrombolyticFilter',
            value: this.thrombolytics ? this.thrombolytics.toString() : null,
          },
          {
            FieldName: 'TeleQPSFilter',
            value: this.selectedTeleneuro_QPS
              ? this.selectedTeleneuro_QPS.toString()
              : null,
          },
          {
            FieldName: 'QPSReviewCompleted',
            value: this.qpsReviewCompleted
              ? this.qpsReviewCompleted.toString()
              : null,
          },
          {
            FieldName: 'DoortoNeedle',
            value: this.doortoNeedleTime
              ? this.doortoNeedleTime.toString()
              : null,
          },
        ],
        data: {
          PatientType: this.advanceFormSearch.controls['work_flow_type'].value
            ? this.advanceFormSearch.controls['work_flow_type'].value
            : [],
        },
      };
      if (this.timeFrame == 'DateRange') {
        if (this.txtStartDate == null) {
          this.txtStartDateErrorBool = true;
        } else {
          this.txtStartDateErrorBool = false;
        }
        if (this.txtEndDate == null) {
          this.txtEndDateErrorBool = true;
        } else {
          this.txtEndDateErrorBool = false;
        }
        if (this.txtStartDate != null && this.txtEndDate != null) {
          let txtStartDate = new Date(this.txtStartDate);
          let txtEndDate = new Date(this.txtEndDate);
          if (txtStartDate > txtEndDate) {
            this.dateRangeBool = true;
          } else {
            this.dateRangeBool = false;
          }
        }
      } else {
        this.txtStartDateErrorBool = false;
        this.txtEndDateErrorBool = false;
        this.dateRangeBool = false;
      }

      if (this.timeFrame == 'SpecificDate') {
        if (this.txtSpecificDate == null) {
          this.txtSpecificDateErrorBool = true;
        } else {
          this.txtSpecificDateErrorBool = false;
        }
      } else {
        this.txtSpecificDateErrorBool = false;
      }
    }
  }

  getAllCases(value: any, advanceSearchLoader: any) {
    this.excelBool = false;
    if (
      value == 'audioOnly' ||
      value == 'status' ||
      value == 'followUp' ||
      value == 'flag' ||
      value == 'qps' ||
      value == 'thrombolytics' ||
      value == 'qpsReview' ||
      value == 'doortoNeedleTime' ||
      value == 'caseType' ||
      value == 'facilityIDs' ||
      value == 'advance'
    ) {
      this.rows = 15;
      this.pageNumber = 1;
      this.clearSearchBool = true;
      this.advanceFormSearch.patchValue({ folowUp: [] });
    }
    if (value == 'search-btn') {
      this.clearSearchBool = true;
    }
    this.txtSpecificDate = this.datePipe.transform(
      this.txtSpecificDate,
      'MM/dd/yyyy'
    );
    this.txtStartDate = this.datePipe.transform(
      this.txtStartDate,
      'MM/dd/yyyy'
    );
    this.txtEndDate = this.datePipe.transform(this.txtEndDate, 'MM/dd/yyyy');
    this.checkEmptyFields();
    this.advanceSearchLoader = advanceSearchLoader;
    if (
      this.txtStartDateErrorBool == false &&
      this.txtEndDateErrorBool == false &&
      this.txtSpecificDateErrorBool == false &&
      this.dateRangeBool == false
    ) {
      if (advanceSearchLoader == false) {
        this.showProgressSpinner = true;
      }
      this.subscription.push(
        this.analyzeService
          .getAllCases(this.RoleName, this.UId, this.data)
          .subscribe({
            next: (res: any) => {
              if (this.advanceSearchLoader == true) {
                this.advanceSearchLoader = false;
              }
              if (res.data.length == 0) {
                this.noRecordBool = true;
              } else {
                this.noRecordBool = false;
              }
              if (res) {
                this.cases = res.data;
                if (this.cases.length > 0) {
                  this.cases.forEach((item: any) => {
                    let caseStatus = this.statusList.filter((x: any) => {
                      return x.value == item.CaseStatus;
                    });
                    if (caseStatus.length > 0) {
                      item.caseStatusLabel = caseStatus[0].name;
                    }
                    if (item.CaseStartTime == '1900-01-01T00:00:00') {
                      item.CaseStartTime = '';
                    }
                  });
                }
                this.advanceSearchModal = false;
                if (value == 'advance' || value == 'search-btn') {
                  this.clearSearchBool = true;
                }

                this.totalRecords = res.Total;
                if (this.showProgressSpinner == true) {
                  this.showProgressSpinner = false;
                }

                this.analyzeService.currentDateTime();
                this.CheckRoleAccess();
              }
            },
            error: (err: any) => {},
          })
      );
    } else {
      if (this.txtStartDateErrorBool == true) {
        this.messageService.add({
          key: 'save',
          severity: 'error',
          summary: 'Please ',
          detail: 'Please select Start Date first.',
        });
        this.textStrtColorBool = true;
        setTimeout(() => {
          this.textStrtColorBool = false;
        }, 1000);
        return;
      }
      if (this.txtEndDateErrorBool == true) {
        this.messageService.add({
          key: 'save',
          severity: 'error',
          summary: 'Please ',
          detail: 'Please select End Date first.',
        });
        this.textEndColorBool = true;
        setTimeout(() => {
          this.textEndColorBool = false;
        }, 1000);
        return;
      }
      if (this.txtSpecificDateErrorBool == true) {
        this.messageService.add({
          key: 'save',
          severity: 'error',
          summary: 'Please ',
          detail: 'Please select Date first.',
        });
        this.specificDatecolorBool = true;
        setTimeout(() => {
          this.specificDatecolorBool = false;
        }, 1000);
        return;
      }
      if (this.dateRangeBool == true) {
        this.messageService.add({
          key: 'save',
          severity: 'error',
          summary: 'Please ',
          detail: 'End Date should be greater than Start Date.',
        });
        // this.textStrtColorBool = true;
        this.textEndColorBool = true;
        setTimeout(() => {
          // this.textStrtColorBool = false;
          this.textEndColorBool = false;
        }, 1000);
        return;
      }
    }
  }

  CheckRoleAccess() {
    this.roleAccessResult = JSON.parse(
      this.helperService.decryption(localStorage.getItem('roleAccessResult'))
    );
    let leaderShipResult = this.roleAccessResult.filter((x: any) => {
      return x.com_page_title == MenuItemsAccess.LeadershipReadWrite;
    });
    let InternalNotesResult = this.roleAccessResult.filter((x: any) => {
      return x.com_page_title == MenuItemsAccess.InternalNotes;
    });
    let TFLAResult = this.roleAccessResult.filter((x: any) => {
      return x.com_page_title == MenuItemsAccess.TFLA;
    });
    let PhysicionHistoryResult = this.roleAccessResult.filter((x: any) => {
      return x.com_page_title == MenuItemsAccess.PhysicianHistory;
    });

    const accessData = this.accessControlService.checkAccess(
      MenuItemsAccess.RCARead,
      MenuItemsAccess.RCAReadWrite
    );
    this.isAccessRead = accessData.isAccessRead;
    this.isAccessReadWrite = accessData.isAccessReadWrite;

    if (
      leaderShipResult[0].com_page_title ==
        MenuItemsAccess.LeadershipReadWrite &&
      leaderShipResult[0].cac_isAllowed == true
    ) {
      this.isAccessLeaderShipReview = true;
    }
    if (
      InternalNotesResult[0].com_page_title == MenuItemsAccess.InternalNotes &&
      InternalNotesResult[0].cac_isAllowed == true
    ) {
      this.isAccessInternalNotes = true;
    } else {
      this.isAccessInternalNotes = false;
    }
    if (
      TFLAResult[0].com_page_title == MenuItemsAccess.TFLA &&
      TFLAResult[0].cac_isAllowed == true
    ) {
      this.isAccessTFLA = true;
    } else {
      this.isAccessTFLA = false;
    }
    if (
      PhysicionHistoryResult[0].com_page_title ==
        MenuItemsAccess.PhysicianHistory &&
      PhysicionHistoryResult[0].cac_isAllowed == true
    ) {
      this.isAccessPhysicionHistory = true;
    } else {
      this.isAccessPhysicionHistory = false;
    }

    this.isAccessReadWrite && !this.roleForFacility
      ? (this.toolTip = 'Double Click to Edit')
      : (this.toolTip = 'Double Click to View');
  }

  toolTipOption(cases: string): string {
    return cases == 'Stroke Alert' || cases == 'STAT Consult'
      ? this.toolTip
      : '';
  }

  ClearSearch() {
    if (this.selectedFacility.length > 0) {
      this.selectedFacility = [];
    }
    if (this.selectedPhysicion.length > 0) {
      this.selectedPhysicion = [];
    }
    if (this.doortoNeedleTime.length > 0) {
      this.doortoNeedleTime = [];
    }
    if (this.qpsReviewCompleted.length > 0) {
      this.qpsReviewCompleted = [];
    }
    if (this.selectedTeleneuro_QPS.length > 0) {
      this.selectedTeleneuro_QPS = [];
    }
    if (this.cas_case_type.length > 0) {
      this.cas_case_type = [];
    }
    if (this.thrombolytics.length > 0) {
      this.thrombolytics = [];
    }

    this.audioOnly = '';
    this.folowUp = '';
    this.timeFrame = 'Last48Hours';
    this.casIsFlagged = '';
    this.searchField = '';
    this.filterVal = '';
    this.advanceFormSearch.reset();
    if (this.txtSpecificDate) {
      this.txtSpecificDate = '';
      this.showDateBool = false;
    }
    if (this.txtStartDate || this.txtEndDate) {
      this.txtStartDate = '';
      this.txtEndDate = '';
      this.showStartEndDateBool = false;
    }
    this.clearSearchBool = false;
    this.crossSearchBool = false;
    if (this.status.length > 0) {
      this.status = [];
    }
    this.getAllCases('', false);
  }

  GetFacilityPhysicion() {
    if (this.physicionList && this.physicionList.length > 0) {
      return;
    }
    if (this.selectedFacility.length > 0) {
      this.physicionList = [];
      this.selectedPhysicion = [];
      this.subscription.push(
        this.analyzeService
          .GetFacilityPhysician(this.selectedFacility)
          .subscribe({
            next: (res: any) => {
              if (res) {
                this.physicionList = res?.data;
              }
            },
            error: (err: any) => {},
          })
      );
    } else {
      this.physicionList = [];
      this.selectedPhysicion = [];
      let facility: any = [];
      this.subscription.push(
        this.analyzeService.GetFacilityPhysician(facility).subscribe({
          next: (res: any) => {
            if (res) {
              this.physicionList = res?.data;
            }
          },
          error: (err: any) => {},
        })
      );
    }
  }

  onChangeTimeFrame(event: any) {
    if (event.value == this.timeFameList[10].value) {
      this.showStartEndDateBool = true;
    } else {
      this.showStartEndDateBool = false;
    }
    if (event.value == this.timeFameList[9].value) {
      this.showDateBool = true;
    } else {
      this.showDateBool = false;
    }
    this.rows = 15;
    this.pageNumber = 1;
    if (
      event.value != this.timeFameList[10].value &&
      event.value != this.timeFameList[9].value
    ) {
      this.clearSearchBool = true;
      this.getAllCases('', false);
    }
  }
  lazyLoadSchedules(event: any) {
    if (event != undefined) {
      this.rows = event.rows;
      this.pageNumber = event.first / this.rows + 1;
      this.sortOrder =
        event.multiSortMeta == undefined || event.multiSortMeta[0].order == -1
          ? 'DESC'
          : 'ASC';
      this.sortCol =
        event.multiSortMeta == undefined ? '' : event.multiSortMeta[0].field;
      this.searchField.length > 0
        ? (this.crossSearchBool = true)
        : (this.crossSearchBool = false);
      this.getAllCases('', false);
    }
  }
  Accesscase(data: any) {
    if (data == '') {
      this.caseKey;
    } else {
      this.caseKey = data.CaseKey;
    }
    this.accessCase =
      this.teleUrl + `Case/Edit/${this.caseKey}?showPopupOnLoad=true`;
    window.open(this.accessCase);
  }
  getCaseDetailByDoubleClick(cases: any) {
    if (cases.CaseType == 'Stroke Alert' || cases.CaseType == 'STAT Consult') {
      let bool: any;
      this.isAccessReadWrite && !this.roleForFacility
        ? (bool = false)
        : (bool = true);
      this.getCaseDetailByCaseId(cases, bool);
    }
  }
  Viewcasereview(data: any) {
    this.getCaseDetailByCaseId(data, true);
  }

  getCaseDetailByCaseId(
    data: any,
    isReadOnly: boolean = false,
    IsGenerateTemplate: boolean = false
  ) {
    this.SelectedCaseEdit = [];
    this.treeSelected = [];
    this.treeSelection = [];
    this.SelectedCaseEdit = [];
    this.activationParentArray = [];
    this.assessmentParentArray = [];
    this.thrombolyticAdmParentArray = [];
    this.thrombolyticDecParentArray = [];
    this.lastChildrenArray = [];
    this.finalTreeSelected = [];
    this.unSelectArray = [];
    this.activationIds = '';
    this.assessmentIds = '';
    this.thrombolyticAdmIds = '';
    this.thrombolyticDecIds = '';
    this.counterMeasuresBool = false;
    this.showProgressSpinner = true;
    this.EditScreenBool = true;
    this.isReadonly = isReadOnly;
    this.caseDetail = data;
    this.caseKey = data.CaseKey;
    this.facilityName = data.FacilityName;
    this.SelectedCaseEdit = this.cases.filter(
      (a: any) => a.CASENumber == data.CASENumber
    );
    if (this.SelectedCaseEdit.length > 0) {
      this.SelectedCaseEdit[0].CASEIdentificationTYPE =
        this.SelectedCaseEdit[0]?.CASEIdentificationTYPE?.concat(':').concat(
          this.SelectedCaseEdit[0]?.CASEIdentificatinNumber != null
            ? this.SelectedCaseEdit[0]?.CASEIdentificatinNumber
            : 'N/A'
        );
    }
    this.caseHeaderName = 'Edit Case Review';
    if (isReadOnly == true) {
      this.caseHeaderName = 'View Case Review';
    }
    this.caseStatus = data.CaseStatus;
    this.accessCase =
      this.teleUrl + `Case/Edit/${this.caseKey}?showPopupOnLoad=true`;
    this.caseStartTime = data.CaseStartTime;
    this.countermeasureRecord().clear();
    this.form.reset();
    this.subscription.push(
      this.analyzeService.getCaseDetailByCaseId(this.caseKey).subscribe({
        next: (res: any) => {
          try {
            this.caseReviewTemplateButtonName =
              res.CaseReviewTemplateButtonName;
            IsGenerateTemplate ? '' : (this.showProgressSpinner = false);
            this.timeZone = res.timeZone;
            this.case_leadership_review = res.data.case_leadership_review;
            this.caseLeadershipReviewDataBind();
            this.qpsList = res.data.QPS;
            this.directorList = res.directorList;
            this.listReviewers = res.listReviewers;
            this.peerReviewPhysicians = res.peerReviewPhysicians;
            this.caseResponse = res.data;
            this.SelectedNodesText = res.SelectedNodesText ?? [];
            if (this.SelectedNodesText.length > 0) {
              this.SelectedNodesText = this.SelectedNodesText.filter(
                (val: any) => val.toLowerCase() !== 'not applicable'
              );
            }
            let Data;
            this.leaderReviewingDropdown = [];
            this.listReviewersDropdown = [];
            this.directorListDropdown = [];
            this.peerReviewPhysicionDropdown = [];

            if (this.qpsList != undefined && this.qpsList != null) {
              for (let index = 0; index <= this.qpsList.length - 1; index++) {
                Data = {
                  FullName: this.qpsList[index].FirstName.concat(' ').concat(
                    this.qpsList[index].LastName
                  ),
                  Id: this.qpsList[index].Id,
                };
                this.leaderReviewingDropdown.push(Data);
              }
            }
            if (this.listReviewers != undefined && this.listReviewers != null) {
              for (let index = 0; index < this.listReviewers.length; index++) {
                Data = {
                  FullName: this.listReviewers[index].FirstName.concat(
                    ' '
                  ).concat(this.listReviewers[index].LastName),
                  Id: this.listReviewers[index].Id,
                };
                this.listReviewersDropdown.push(Data);
              }
            }
            if (this.directorList != undefined && this.directorList != null) {
              for (let index = 0; index < this.directorList.length; index++) {
                Data = {
                  FullName: this.directorList[index].FirstName.concat(
                    ' '
                  ).concat(this.directorList[index].LastName),
                  Id: this.directorList[index].Id,
                };
                this.directorListDropdown.push(Data);
              }
            }
            if (
              this.peerReviewPhysicians != undefined &&
              this.peerReviewPhysicians != null
            ) {
              for (
                let index = 0;
                index < this.peerReviewPhysicians.length;
                index++
              ) {
                const firstName =
                  this.peerReviewPhysicians[index].FirstName || '';
                const lastName =
                  this.peerReviewPhysicians[index].LastName || '';

                const Data = {
                  FullName: `${firstName} ${lastName}`,
                  Id: this.peerReviewPhysicians[index].Id,
                };

                this.peerReviewPhysicionDropdown.push(Data);
              }
            }
            this.editCaseData = res.data;
            if (this.editCaseData) {
              Object.keys(this.editCaseData).forEach((key) => {
                if (typeof this.editCaseData[key] === 'string') {
                  const isDate = !isNaN(Date.parse(this.editCaseData[key]));
                  if (isDate && this.editCaseData[key].includes('Z')) {
                    this.editCaseData[key] = this.editCaseData[key].slice(
                      0,
                      -1
                    );
                  }
                }
              });
            }
            if (this.editCaseData.caseTypeName == 'STAT Consult') {
              this.isTemplateBool = false;
            } else {
              this.isTemplateBool = true;
            }

            if (
              this.editCaseData.cas_patient_type == 1 ||
              this.editCaseData.cas_patient_type == 3 ||
              this.editCaseData.cas_patient_type == 2 ||
              this.editCaseData.cas_patient_type == 4
            ) {
              this.TATimelineBool = false;
              this.markActivation = true;
              this.markAssesment = true;
              this.markThrombolytic = true;
              this.markThrombolytic = true;
              if (this.editCaseData.cas_metric_door_time_est == null) {
                this.activation_circle_time = 'N/A';
                this.arrival_time_before_circle = 'N/A';
              } else {
                let caseStartTime: any = this.datePipe.transform(
                  this.caseStartTime,
                  'HH:mm:ss'
                );
                let cas_metric_door_time_est: any = this.datePipe.transform(
                  this.editCaseData.cas_metric_door_time_est,
                  'HH:mm:ss'
                );
                this.arrival_time_before_circle = cas_metric_door_time_est;
                let catogary: any;
                this.CalculateTime(
                  caseStartTime,
                  cas_metric_door_time_est,
                  (catogary = 'activation-time')
                );
              }
            } else {
              this.TATimelineBool = true;
              this.markActivation = false;
              this.markAssesment = false;
              this.markThrombolytic = false;
              this.markThrombolytic = false;
              this.before_circle_bool = false;
            }

            this.patchingMedicalDirectoreModule();
            this.reviewCompletedBool =
              this.editCaseData.cas_response_MD_review_check;
            if (this.editCaseData.cas_metric_tpa_consult == true) {
              this.thrombolyticCandidateBool = true;
            } else {
              this.thrombolyticCandidateBool = false;
            }
            if (
              this.editCaseData.cas_billing_date_of_consult != null &&
              this.editCaseData.cas_billing_date_of_consult != undefined
            ) {
              let cas_billing_date_of_consult_Date = new Date(
                this.editCaseData.cas_billing_date_of_consult
              );
              this.editCaseData.cas_billing_date_of_consult =
                cas_billing_date_of_consult_Date;
            }
            if (this.editCaseData.cas_response_MD_to_review == 1) {
              this.casResponseMDToreviewBool = true;
              this.form.patchValue({
                cas_response_MD_to_review:
                  this.editCaseData.cas_response_MD_to_review,
              });
            } else {
              this.casResponseMDToreviewBool = false;
              this.form.patchValue({
                cas_response_MD_to_review:
                  this.editCaseData.cas_response_MD_to_review,
              });
            }
            if (this.editCaseData.cas_response_peer_review == 1) {
              this.PeerReviewRequestedBool = true;
              this.form.patchValue({
                cas_response_MD_to_review:
                  this.editCaseData.cas_response_MD_to_review,
              });
            }
            if (this.editCaseData.cas_response_peer_review == 1) {
              this.PeerReviewRequestedBool = true;
              this.form.patchValue({
                cas_response_peer_review:
                  this.editCaseData.cas_response_peer_review,
              });
            } else {
              this.PeerReviewRequestedBool = false;
              this.form.patchValue({
                cas_response_peer_review:
                  this.editCaseData.cas_response_peer_review,
              });
            }
            if (this.editCaseData.cas_response_thrombolytic == true) {
              this.thrombolyticComplicationBool = true;
              this.editCaseData.cas_response_thrombolytic = 1;
            } else {
              this.thrombolyticComplicationBool = false;
              this.editCaseData.cas_response_thrombolytic = 2;
            }
            if (this.editCaseData.cas_response_case_qps_reviewed == 1) {
              this.QPSReviewField = true;
              this.form.patchValue({
                cas_response_case_qps_reviewed:
                  (this.editCaseData.cas_response_case_qps_reviewed = true),
              });
            } else {
              this.QPSReviewField = false;
              this.form.patchValue({
                cas_response_case_qps_reviewed:
                  (this.editCaseData.cas_response_case_qps_reviewed = false),
              });
            }
            if (this.editCaseData.cas_case_summary_sent_to_facility == 1) {
              this.form.patchValue({
                cas_case_summary_sent_to_facility:
                  (this.editCaseData.cas_case_summary_sent_to_facility = true),
              });
            } else {
              this.form.patchValue({
                cas_case_summary_sent_to_facility:
                  (this.editCaseData.cas_case_summary_sent_to_facility = false),
              });
            }

            if (this.editCaseData.cas_operations_review_completed == 1) {
              this.OperationsReview = true;
              this.form.patchValue({
                cas_operations_review_completed:
                  (this.editCaseData.cas_operations_review_completed = true),
              });
            } else {
              this.OperationsReview = false;
              this.form.patchValue({
                cas_operations_review_completed:
                  (this.editCaseData.cas_operations_review_completed = false),
              });
            }
            if (
              this.editCaseData.cas_review_qps_reviewed_completed != null &&
              this.editCaseData.cas_review_qps_reviewed_completed != undefined
            ) {
              let cas_review_qps_reviewed_completed = this.datePipe.transform(
                this.editCaseData.cas_review_qps_reviewed_completed,
                'MM/dd/yyyy HH:mm:ss'
              );
              this.editCaseData.cas_review_qps_reviewed_completed =
                cas_review_qps_reviewed_completed;
              this.form.controls[
                'cas_review_qps_reviewed_completed'
              ].patchValue(this.editCaseData.cas_review_qps_reviewed_completed);
              this.QpsCompletedEst = true;
            }
            if (
              this.editCaseData.cas_response_operations_review_completed !=
                null &&
              this.editCaseData.cas_response_operations_review_completed !=
                undefined
            ) {
              let cas_response_operations_review_completed =
                this.datePipe.transform(
                  this.editCaseData.cas_response_operations_review_completed,
                  'MM/dd/yyyy HH:mm:ss'
                );
              this.editCaseData.cas_response_operations_review_completed =
                cas_response_operations_review_completed;
              this.form.controls[
                'cas_response_operations_review_completed'
              ].patchValue(
                this.editCaseData.cas_response_operations_review_completed
              );
              this.OperationsCompletedEst = true;
            }
            if (
              this.editCaseData.cas_response_peer_review_assignment_stamp !=
                null &&
              this.editCaseData.cas_response_peer_review_assignment_stamp !=
                undefined
            ) {
              let cas_response_peer_review_assignment_stamp =
                this.datePipe.transform(
                  this.editCaseData.cas_response_peer_review_assignment_stamp,
                  'MM/dd/yyyy HH:mm:ss'
                );
              this.editCaseData.cas_response_peer_review_assignment_stamp =
                cas_response_peer_review_assignment_stamp;
              this.form.controls[
                'cas_response_peer_review_assignment_stamp'
              ].patchValue(
                this.editCaseData.cas_response_peer_review_assignment_stamp
              );
              this.PreeAssignmentEst = true;
            }
            if (this.editCaseData.cas_metric_is_lastwell_unknown == true) {
              this.form.patchValue({
                cas_metric_lastwell_date_est: ['Unknown'],
              });
            } else if (
              this.editCaseData.cas_metric_lastwell_date_est != null &&
              this.editCaseData.cas_metric_is_lastwell_unknown == false
            ) {
              this.cas_metric_lastwell_date_est_for_color =
                this.datePipe.transform(
                  this.editCaseData.cas_metric_lastwell_date_est,
                  'MM/dd/yyyy HH:mm:ss'
                );
              let cas_metric_lastwell_date_est = this.datePipe.transform(
                this.editCaseData.cas_metric_lastwell_date_est,
                'MM/dd/yyyy HH:mm:ss'
              );

              this.editCaseData.cas_metric_lastwell_date_est =
                cas_metric_lastwell_date_est;
              this.form.patchValue({
                cas_metric_lastwell_date_est:
                  this.editCaseData.cas_metric_lastwell_date_est,
              });
            }
            if (
              this.editCaseData.cas_response_peer_review_initiated_stamp !=
                null &&
              this.editCaseData.cas_response_peer_review_initiated_stamp !=
                undefined
            ) {
              let cas_response_peer_review_initiated_stamp =
                this.datePipe.transform(
                  this.editCaseData.cas_response_peer_review_initiated_stamp,
                  'MM/dd/yyyy HH:mm:ss'
                );
              this.editCaseData.cas_response_peer_review_initiated_stamp =
                cas_response_peer_review_initiated_stamp;
              this.form.controls[
                'cas_response_peer_review_initiated_stamp'
              ].patchValue(
                this.editCaseData.cas_response_peer_review_initiated_stamp
              );
              this.PreeInitiatedEst = true;
            }
            if (
              this.editCaseData.cas_response_peer_review_completed_stamp !=
                null &&
              this.editCaseData.cas_response_peer_review_completed_stamp !=
                undefined
            ) {
              let cas_response_peer_review_completed_stamp =
                this.datePipe.transform(
                  this.editCaseData.cas_response_peer_review_completed_stamp,
                  'MM/dd/yyyy HH:mm:ss'
                );
              this.editCaseData.cas_response_peer_review_completed_stamp =
                cas_response_peer_review_completed_stamp;
              this.form.controls[
                'cas_response_peer_review_completed_stamp'
              ].patchValue(
                this.editCaseData.cas_response_peer_review_completed_stamp
              );
              this.PreecompletedEst = true;
            }
            if (
              this.editCaseData.cas_response_MD_assignment_datetime != null &&
              this.editCaseData.cas_response_MD_assignment_datetime != undefined
            ) {
              let cas_response_MD_assignment_datetime = this.datePipe.transform(
                this.editCaseData.cas_response_MD_assignment_datetime,
                'MM/dd/yyyy HH:mm:ss'
              );
              this.editCaseData.cas_response_MD_assignment_datetime =
                cas_response_MD_assignment_datetime;
              this.form.controls[
                'cas_response_MD_assignment_datetime'
              ].patchValue(
                this.editCaseData.cas_response_MD_assignment_datetime
              );
              this.MdDateEst = true;
            }
            this.cas_metric_door_time_est = this.datePipe.transform(
              this.editCaseData.cas_metric_door_time_est,
              'MM/dd/yyyy HH:mm:ss'
            );
            this.editCaseData.cas_metric_door_time_est =
              this.datePipe.transform(
                this.editCaseData.cas_metric_door_time_est,
                'MM/dd/yyyy HH:mm:ss'
              );
            if (this.editCaseData.cas_metric_tpa_consult == true) {
              this.thrombolyticCandidateBool = true;
            } else {
              this.thrombolyticCandidateBool = false;
            }
            if (
              this.editCaseData.cas_billing_date_of_consult != null &&
              this.editCaseData.cas_billing_date_of_consult != undefined
            ) {
              let cas_billing_date_of_consult_Date = new Date(
                this.editCaseData.cas_billing_date_of_consult
              );
              this.editCaseData.cas_billing_date_of_consult =
                cas_billing_date_of_consult_Date;
            } else {
              this.editCaseData.cas_billing_date_of_consult = new Date();
            }
            if (this.editCaseData.cas_response_MD_to_review == 1) {
              this.casResponseMDToreviewBool = true;
              this.form.patchValue({
                cas_response_MD_to_review:
                  this.editCaseData.cas_response_MD_to_review,
              });
            } else {
              this.casResponseMDToreviewBool = false;
              this.form.patchValue({
                cas_response_MD_to_review:
                  this.editCaseData.cas_response_MD_to_review,
              });
            }
            if (this.editCaseData.cas_response_peer_review == 1) {
              this.PeerReviewRequestedBool = true;
              this.form.patchValue({
                cas_response_MD_to_review:
                  this.editCaseData.cas_response_MD_to_review,
              });
            }
            if (this.editCaseData.cas_response_peer_review == 1) {
              this.PeerReviewRequestedBool = true;
              this.form.patchValue({
                cas_response_peer_review:
                  this.editCaseData.cas_response_peer_review,
              });
            } else {
              this.PeerReviewRequestedBool = false;
              this.form.patchValue({
                cas_response_peer_review:
                  this.editCaseData.cas_response_peer_review,
              });
            }
            // if (this.editCaseData.cas_response_thrombolytic == true) {
            //   this.thrombolyticComplicationBool = true;
            //   this.editCaseData.cas_response_thrombolytic = 1;
            // } else {
            //   this.thrombolyticComplicationBool = false;
            //   this.editCaseData.cas_response_thrombolytic = 2;
            // }
            if (this.editCaseData.cas_response_case_qps_reviewed == 1) {
              this.QPSReviewField = true;
              this.form.patchValue({
                cas_response_case_qps_reviewed:
                  (this.editCaseData.cas_response_case_qps_reviewed = true),
              });
            } else {
              this.QPSReviewField = false;
              this.form.patchValue({
                cas_response_case_qps_reviewed:
                  (this.editCaseData.cas_response_case_qps_reviewed = false),
              });
            }

            if (this.editCaseData.cas_operations_review_completed == 1) {
              this.OperationsReview = true;
              this.form.patchValue({
                cas_operations_review_completed:
                  (this.editCaseData.cas_operations_review_completed = true),
              });
            } else {
              this.OperationsReview = false;
              this.form.patchValue({
                cas_operations_review_completed:
                  (this.editCaseData.cas_operations_review_completed = false),
              });
            }
            if (
              this.editCaseData.cas_review_qps_reviewed_completed != null &&
              this.editCaseData.cas_review_qps_reviewed_completed != undefined
            ) {
              let cas_review_qps_reviewed_completed = this.datePipe.transform(
                this.editCaseData.cas_review_qps_reviewed_completed,
                'MM/dd/yyyy HH:mm:ss'
              );
              this.editCaseData.cas_review_qps_reviewed_completed =
                cas_review_qps_reviewed_completed;
              this.form.controls[
                'cas_review_qps_reviewed_completed'
              ].patchValue(this.editCaseData.cas_review_qps_reviewed_completed);
            }
            if (
              this.editCaseData.cas_response_operations_review_completed !=
                null &&
              this.editCaseData.cas_response_operations_review_completed !=
                undefined
            ) {
              let cas_response_operations_review_completed =
                this.datePipe.transform(
                  this.editCaseData.cas_response_operations_review_completed,
                  'MM/dd/yyyy HH:mm:ss'
                );
              this.editCaseData.cas_response_operations_review_completed =
                cas_response_operations_review_completed;
              this.form.controls[
                'cas_response_operations_review_completed'
              ].patchValue(
                this.editCaseData.cas_response_operations_review_completed
              );
            }
            if (
              this.editCaseData.cas_response_peer_review_assignment_stamp !=
                null &&
              this.editCaseData.cas_response_peer_review_assignment_stamp !=
                undefined
            ) {
              let cas_response_peer_review_assignment_stamp =
                this.datePipe.transform(
                  this.editCaseData.cas_response_peer_review_assignment_stamp,
                  'MM/dd/yyyy HH:mm:ss'
                );
              this.editCaseData.cas_response_peer_review_assignment_stamp =
                cas_response_peer_review_assignment_stamp;
              this.form.controls[
                'cas_response_peer_review_assignment_stamp'
              ].patchValue(
                this.editCaseData.cas_response_peer_review_assignment_stamp
              );
            }
            if (
              this.editCaseData.cas_response_peer_review_initiated_stamp !=
                null &&
              this.editCaseData.cas_response_peer_review_initiated_stamp !=
                undefined
            ) {
              let cas_response_peer_review_initiated_stamp =
                this.datePipe.transform(
                  this.editCaseData.cas_response_peer_review_initiated_stamp,
                  'MM/dd/yyyy HH:mm:ss'
                );
              this.editCaseData.cas_response_peer_review_initiated_stamp =
                cas_response_peer_review_initiated_stamp;
              this.form.controls[
                'cas_response_peer_review_initiated_stamp'
              ].patchValue(
                this.editCaseData.cas_response_peer_review_initiated_stamp
              );
            }
            if (
              this.editCaseData.cas_response_peer_review_completed_stamp !=
                null &&
              this.editCaseData.cas_response_peer_review_completed_stamp !=
                undefined
            ) {
              let cas_response_peer_review_completed_stamp =
                this.datePipe.transform(
                  this.editCaseData.cas_response_peer_review_completed_stamp,
                  'MM/dd/yyyy HH:mm:ss'
                );
              this.editCaseData.cas_response_peer_review_completed_stamp =
                cas_response_peer_review_completed_stamp;
              this.form.controls[
                'cas_response_peer_review_completed_stamp'
              ].patchValue(
                this.editCaseData.cas_response_peer_review_completed_stamp
              );
            }
            if (
              this.editCaseData.cas_response_MD_assignment_datetime != null &&
              this.editCaseData.cas_response_MD_assignment_datetime != undefined
            ) {
              let cas_response_MD_assignment_datetime = this.datePipe.transform(
                this.editCaseData.cas_response_MD_assignment_datetime,
                'MM/dd/yyyy HH:mm:ss'
              );
              this.editCaseData.cas_response_MD_assignment_datetime =
                cas_response_MD_assignment_datetime;
              this.form.controls[
                'cas_response_MD_assignment_datetime'
              ].patchValue(
                this.editCaseData.cas_response_MD_assignment_datetime
              );
            }

            this.editCaseData.cas_metric_door_time_est =
              this.datePipe.transform(
                this.editCaseData.cas_metric_door_time_est,
                'MM/dd/yyyy HH:mm:ss'
              );

            if (
              this.editCaseData.cas_metric_initial_response_time_est == null ||
              this.editCaseData.cas_metric_initial_response_time_est == ''
            ) {
              this.editCaseData.cas_metric_initial_response_time_est = '';
            } else {
              this.editCaseData.cas_metric_initial_response_time_est = new Date(
                this.editCaseData.cas_metric_initial_response_time_est
              );
              this.Temp_cas_metric_initial_response_time_est =
                this.datePipe.transform(
                  this.editCaseData.cas_metric_initial_response_time_est,
                  'HH:mm:ss'
                );
            }
            if (
              this.editCaseData.cas_metric_stamp_time_est == null ||
              this.editCaseData.cas_metric_stamp_time_est == ''
            ) {
              this.editCaseData.cas_metric_stamp_time_est = '';
            } else {
              this.editCaseData.cas_metric_stamp_time_est =
                this.datePipe.transform(
                  this.editCaseData.cas_metric_stamp_time_est,
                  'MM/dd/yyyy HH:mm:ss'
                );
            }
            if (
              this.editCaseData.cas_assessment_time_est == null ||
              this.editCaseData.cas_assessment_time_est == ''
            ) {
              this.editCaseData.cas_assessment_time_est = '';
              this.cas_assessment_time_est_for_color = '';
              this.cas_assessment_time_est_for_circle = 'N/A';
            } else {
              this.cas_assessment_time_est_for_circle = this.datePipe.transform(
                this.editCaseData.cas_assessment_time_est,
                'HH:mm:ss'
              );
              this.cas_assessment_time_est_for_color = this.datePipe.transform(
                this.editCaseData.cas_assessment_time_est,
                'MM/dd/yyyy HH:mm:ss'
              );
              let cas_assessment_time_est = this.datePipe.transform(
                this.editCaseData.cas_assessment_time_est,
                'MM/dd/yyyy HH:mm:ss'
              );
              this.editCaseData.cas_assessment_time_est =
                cas_assessment_time_est;
              this.form.controls['cas_assessment_time_est'].patchValue(
                this.editCaseData.cas_assessment_time_est
              );
            }
            this.cas_response_ts_notification_for_color =
              this.datePipe.transform(
                this.editCaseData.cas_response_ts_notification,
                'MM/dd/yyyy HH:mm:ss'
              );
            this.editCaseData.cas_response_ts_notification =
              this.datePipe.transform(
                this.editCaseData.cas_response_ts_notification,
                'MM/dd/yyyy HH:mm:ss'
              );
            if (
              this.editCaseData.cas_metric_alteplase_medical_decision == null ||
              this.editCaseData.cas_metric_alteplase_medical_decision == ''
            ) {
              this.editCaseData.cas_metric_alteplase_medical_decision = '';
              this.cas_metric_alteplase_medical_decision_for_color = '';
              this.thrombolytic_decision_time = 'N/A';
            } else {
              this.thrombolytic_decision_time = this.datePipe.transform(
                this.editCaseData.cas_metric_alteplase_medical_decision,
                'HH:mm:ss'
              );
              this.cas_metric_alteplase_medical_decision_for_color =
                this.datePipe.transform(
                  this.editCaseData.cas_metric_alteplase_medical_decision,
                  'MM/dd/yyyy HH:mm:ss'
                );
              let cas_metric_alteplase_medical_decision =
                this.datePipe.transform(
                  this.editCaseData.cas_metric_alteplase_medical_decision,
                  'MM/dd/yyyy HH:mm:ss'
                );
              this.editCaseData.cas_metric_alteplase_medical_decision =
                cas_metric_alteplase_medical_decision;
              this.form.controls[
                'cas_metric_alteplase_medical_decision'
              ].patchValue(
                this.editCaseData.cas_metric_alteplase_medical_decision
              );
            }
            if (
              this.editCaseData.cas_metric_needle_time_est == null ||
              this.editCaseData.cas_metric_needle_time_est == ''
            ) {
              this.editCaseData.cas_metric_needle_time_est = '';
              this.thrombolic_administration_circle_time = 'N/A';
            } else {
              this.editCaseData.cas_metric_needle_time_est =
                this.datePipe.transform(
                  this.editCaseData.cas_metric_needle_time_est,
                  'MM/dd/yyyy HH:mm:ss'
                ); // new Date(this.editCaseData.cas_metric_needle_time_est);

              this.thrombolic_administration_circle_time =
                this.datePipe.transform(
                  this.editCaseData.cas_metric_needle_time_est,
                  'HH:mm:ss'
                );
              this.time_for_red_color_needle = this.datePipe.transform(
                this.editCaseData.cas_metric_needle_time_est,
                'MM/dd/yyyy HH:mm:ss'
              );
            }

            this.ArrivalToNeedleTimeBoolean = false;
            if (
              this.editCaseData.cas_patient_type == 1 ||
              this.editCaseData.cas_patient_type == 3
            ) {
              let timeFor45MinutesBool: any;
              // if(this.editCaseData.cas_patient_type == 1 && this.editCaseData.cas_is_pat_arrived == 1){
              this.labelAfterCircle = 'Arrival to Needle Time';
              this.time_after_circle =
                this.editCaseData.CustomCalculation.ArrivalToNeedleTime;
              if (this.time_after_circle) {
                timeFor45MinutesBool = this.convertTimeToMinutes(
                  this.time_after_circle
                );
              }
              // }
              // if((this.editCaseData.cas_patient_type == 1 && this.editCaseData.cas_is_pat_arrived == 0) ||
              // (this.editCaseData.cas_patient_type == 3 && this.editCaseData.cas_is_pat_arrived == 0) ||
              // (this.editCaseData.cas_patient_type == 3 && this.editCaseData.cas_is_pat_arrived == 1)){
              //   this.labelAfterCircle = 'Start to Needle Time';
              //   this.time_after_circle = this.editCaseData.CustomCalculation.StartTimetoNeedleTimeLessThen40Minutes;
              //   if(this.time_after_circle){
              //     timeFor45MinutesBool = this.convertTimeToMinutes(this.time_after_circle);
              //   }
              // }
              if (timeFor45MinutesBool > 45) {
                this.ArrivalToNeedleTimeBoolean = true;
              } else {
                this.ArrivalToNeedleTimeBoolean = false;
              }
              if (this.time_after_circle == '' || !this.time_after_circle) {
                this.time_after_circle = 'N/A';
              }
            } else {
              if (
                this.editCaseData.cas_patient_type == 1 ||
                this.editCaseData.cas_patient_type == 3
              ) {
                this.labelAfterCircle = 'Arrival to Needle Time';
              } else {
                this.labelAfterCircle = 'Start to Needle Time';
              }
              this.time_after_circle = 'N/A';
            }
            if (this.editCaseData.cas_patient_type != null) {
              if (
                this.editCaseData.cas_patient_type == 2 ||
                this.editCaseData.cas_patient_type == 4
              ) {
                let timeFor45MinutesBool: any;
                this.labelAfterCircle = 'Start to Needle Time';
                this.time_after_circle =
                  this.editCaseData.CustomCalculation.StartTimetoNeedleTimeLessThen40Minutes;
                if (this.time_after_circle) {
                  timeFor45MinutesBool = this.convertTimeToMinutes(
                    this.time_after_circle
                  );
                }
                if (timeFor45MinutesBool > 45) {
                  this.ArrivalToNeedleTimeBoolean = true;
                } else {
                  this.ArrivalToNeedleTimeBoolean = false;
                }
                if (this.time_after_circle == '' || !this.time_after_circle) {
                  this.time_after_circle = 'N/A';
                }
                this.before_circle_bool = true;
              } else {
                this.before_circle_bool = false;
              }
            } else {
              this.before_circle_bool = true;
            }
            if (
              this.editCaseData.ctai_nir_discussion_time == null ||
              this.editCaseData.ctai_nir_discussion_time == ''
            ) {
              this.editCaseData.ctai_nir_discussion_time = '';
            } else {
              let ctai_nir_discussion_time = this.datePipe.transform(
                this.editCaseData.ctai_nir_discussion_time,
                'MM/dd/yyyy HH:mm:ss'
              );
              this.editCaseData.ctai_nir_discussion_time =
                ctai_nir_discussion_time;
              this.form.controls['ctai_nir_discussion_time'].patchValue(
                this.editCaseData.ctai_nir_discussion_time
              );
              this.Temp_ctai_nir_discussion_time = this.datePipe.transform(
                this.editCaseData.ctai_nir_discussion_time,
                'HH:mm:ss'
              );
            }

            if (
              this.editCaseData.cas_response_medical_director_reviewer != '' &&
              this.editCaseData.cas_response_medical_director_reviewer != null
            ) {
              this.editCaseData.cas_response_medical_director_reviewer =
                this.editCaseData.cas_response_medical_director_reviewer.split(
                  ','
                );
            }

            if (
              this.editCaseData.cas_response_reviewer != '' &&
              this.editCaseData.cas_response_reviewer != null
            ) {
              this.editCaseData.cas_response_reviewer =
                this.editCaseData.cas_response_reviewer.split(',');
            }
            if (
              this.editCaseData.cas_response_peer_review_Physicians != '' &&
              this.editCaseData.cas_response_peer_review_Physicians != null
            ) {
              this.editCaseData.cas_response_peer_review_Physicians =
                this.editCaseData.cas_response_peer_review_Physicians.split(
                  ','
                );
            }
            this.form.patchValue(this.editCaseData);
            // this.form.controls['cas_is_audio_consult'].patchValue(this.editCaseData.cas_is_audio_consult);
            this.cas_nihss_cannot_completedBool = false;
            this.cas_nihss_reasonBool = false;
            if (this.editCaseData.cas_nihss_cannot_completed) {
              this.cas_nihss_cannot_completedBool = true;
            }
            if (
              this.editCaseData.cas_nihss_cannot_completed &&
              this.editCaseData.cas_NIHSS_comatose == '3'
            ) {
              this.cas_nihss_reasonBool = true;
            }
            this.cas_nihss_totalscore = this.editCaseData.cas_nihss_totalscore;
            this.cas_NIHSS_comatose = this.editCaseData.cas_NIHSS_comatose;

            this.PhysicianName = this.editCaseData.PhysicianName;
            this.RapidiIntervalMetricsConditional();
            this.patchingCorrespondenceModule();

            this.form.patchValue({
              ActivationTimeIntervalMetric:
                this.editCaseData.CustomCalculation
                  .ActivationTimeIntervalMetric,
              ThrombolyticAdministrationIntervalMetric:
                this.editCaseData.CustomCalculation
                  .ThrombolyticAdministrationIntervalMetric,
              ThrombolyticDecisionIntervalMetric:
                this.editCaseData.CustomCalculation
                  .ThrombolyticDecisionIntervalMetric,
              AssessmentTimeIntervalMetric:
                this.editCaseData.CustomCalculation
                  .AssessmentTimeIntervalMetric,
              firstTimeLoginAttemtToNIHSSassTime:
                this.editCaseData.CustomCalculation
                  .TFLAToNIHStartAssessmentTime,
              StartTimetoNeedleTimeLessThen40Minutes:
                this.editCaseData.CustomCalculation
                  .StartTimetoNeedleTimeLessThen40Minutes,
              TFLAtoNeedleTimelessThen30Minutes:
                this.editCaseData.CustomCalculation
                  .TFLAtoNeedleTimelessThen30Minutes,
              ArrivalToNeedleTime:
                this.editCaseData.CustomCalculation.ArrivalToNeedleTime,
              cas_review_qps_reviewed_completed:
                this.editCaseData.cas_review_qps_reviewed_completed,
            });

            this.validationForRCADiagram();
            this.internalNotes = this.editCaseData.cas_review_internal_notes;
            this.tfla = this.datePipe.transform(
              this.editCaseData.cas_response_first_atempt,
              'MM/dd/yyyy HH:mm:ss'
            );
            this.EalertBool = this.editCaseData.cas_is_ealert;
            if (this.EalertBool == false) {
              this.Ealert = 'No';
            }
            if (this.EalertBool == true) {
              this.Ealert = 'Yes';
            }
            if (this.editCaseData.cas_thrombolytic_used == 0) {
              this.thrombolytic_used = 'Alteplase';
            }
            if (this.editCaseData.cas_thrombolytic_used == 1) {
              this.thrombolytic_used = 'Tenecteplase';
            }

            this.workFlowType =
              this.editCaseData.cas_patient_type == 1
                ? 'EMS'
                : this.editCaseData.cas_patient_type == 2
                ? 'Inpatient'
                : this.editCaseData.cas_patient_type == 3
                ? 'Triage/Walk-In'
                : this.editCaseData.cas_patient_type == 4
                ? 'Symptom Onset During ED Stay'
                : '';
            this.ArrivalToNeedleTimeLable =
              this.editCaseData.CustomCalculation.ArrivalToNeedleTimeLable;

            /* subtract time and show Start*/
            let hms1 = this.Temp_cas_metric_initial_response_time_est;
            let hms2 = this.Temp_ctai_nir_discussion_time;

            if (hms2 > hms1) {
              let a = hms1.split(':');
              let b = hms2.split(':');

              let seconds1 = +a[0] * 60 * 60 + +a[1] * 60 + +a[2];
              let seconds2 = +b[0] * 60 * 60 + +b[1] * 60 + +b[2];
              this.initial_response_time_to_Discussed_with_NIR_time =
                seconds2 - seconds1;

              let hours: any = Math.floor(
                this.initial_response_time_to_Discussed_with_NIR_time / 3600
              );
              this.initial_response_time_to_Discussed_with_NIR_time %= 3600;
              let minutes: any = Math.floor(
                this.initial_response_time_to_Discussed_with_NIR_time / 60
              );
              let seconds: any =
                this.initial_response_time_to_Discussed_with_NIR_time % 60;

              minutes = String(minutes).padStart(2, '0');
              hours = String(hours).padStart(2, '0');
              seconds = String(seconds).padStart(2, '0');
              this.initial_response_time_to_Discussed_with_NIR_time =
                hours + ':' + minutes + ':' + seconds;
            } else {
              this.form.patchValue({
                initial_response_time_to_Discussed_with_NIR_time: [''],
              });
            }
            if (
              this.initial_response_time_to_Discussed_with_NIR_time ==
              'NaN:NaN:NaN'
            ) {
              this.form.patchValue({
                initial_response_time_to_Discussed_with_NIR_time: [''],
              });
            } else {
              this.form.patchValue({
                initial_response_time_to_Discussed_with_NIR_time:
                  this.initial_response_time_to_Discussed_with_NIR_time,
              });
            }
          } catch {
          } finally {
            this.fetchHistoryTableData();
            if (this.editCaseData.cas_patient_type != null) {
              this.setThrombolyticAdministrationTimelineFields(
                res.thrombolyticAdministrationTimelineData
              );
              this.loadFishBoneDiagram(IsGenerateTemplate);
            } else {
              this.tPACandidate = false;
              IsGenerateTemplate ? this.generateTemplate() : '';
            }
            this.getRCACountermeasuresByCaseKey(IsGenerateTemplate);
          }
        },
      })
    );
    if (this.caseStatus == 140) {
      this.showSaveBool = true;
      this.isReadonlyUnCancleCase = true;
    } else {
      this.showSaveBool = false;
      this.isReadonlyUnCancleCase = false;
    }
  }

  convertTimeToMinutes(timeString: string): number {
    const [hours, minutes, seconds] = timeString.split(':').map(Number);
    return hours * 60 + minutes + seconds / 60;
  }

  CalculateTime(time1: any, time2: any, category: string) {
    const timeFormat = (time: string) =>
      time ? time.split(':').map(Number) : [0, 0, 0];
    const [hours1, minutes1, seconds1] = timeFormat(time1);
    const [hours2, minutes2, seconds2] = timeFormat(time2);

    if (
      hours1 > hours2 ||
      (hours1 === hours2 && minutes1 > minutes2) ||
      (hours1 === hours2 && minutes1 === minutes2 && seconds1 > seconds2)
    ) {
      const timeInSeconds =
        (hours1 - hours2) * 3600 +
        (minutes1 - minutes2) * 60 +
        (seconds1 - seconds2);

      if (category === 'circle-end-time') {
        this.time_after_circle =
          timeInSeconds >= 0
            ? `${String((timeInSeconds / 3600) | 0).padStart(2, '0')}:${String(
                ((timeInSeconds / 60) | 0) % 60
              ).padStart(2, '0')}:${String(timeInSeconds % 60).padStart(
                2,
                '0'
              )}`
            : 'N/A';
      } else if (category === 'activation-time') {
        this.activation_circle_time =
          timeInSeconds >= 0
            ? `${String((timeInSeconds / 3600) | 0).padStart(2, '0')}:${String(
                ((timeInSeconds / 60) | 0) % 60
              ).padStart(2, '0')}:${String(timeInSeconds % 60).padStart(
                2,
                '0'
              )}`
            : 'N/A';
      }
    } else {
      if (category === 'circle-end-time') {
        this.time_after_circle = 'N/A';
      } else if (category === 'activation-time') {
        this.activation_circle_time = 'N/A';
      }
    }
  }
  unCancelCase() {
    this.showProgressSpinner = true;
    this.subscription.push(
      this.measureService.UnCancelCase(this.caseKey).subscribe({
        next: (res: any) => {
          if (res.msg == 'success') {
            this.EditScreenBool = false;
            this.showProgressSpinner = false;
            this.messageService.add({
              key: 'cancleCase',
              severity: 'success',
              summary: 'Success',
              detail: 'Case Cancle Successfuly',
            });
          }
        },
        error: (err: any) => {},
      })
    );
  }
  setThrombolyticAdministrationTimelineFields(
    thrombolyticAdministrationTimelineData: any
  ) {
    if (this.editCaseData.cas_patient_type != null) {
      this.workflowtypeForTimeline =
        this.editCaseData.cas_patient_type == 1
          ? 'EMS'
          : this.editCaseData.cas_patient_type == 2
          ? 'Inpatient'
          : this.editCaseData.cas_patient_type == 3
          ? 'Triage/Walk-In'
          : this.editCaseData.cas_patient_type == 4
          ? 'Symptom Onset During ED Stay'
          : '';
      this.tPACandidate = this.editCaseData.cas_metric_tpa_consult;
      if (this.tPACandidate) {
        this._startime =
          this.editCaseData.cas_response_ts_notification == ''
            ? '00:00'
            : this.datePipe.transform(
                this.editCaseData.cas_response_ts_notification,
                'HH:mm'
              );
        this._logintime =
          this.editCaseData.cas_response_first_atempt == ''
            ? '00:00'
            : this.datePipe.transform(
                this.editCaseData.cas_response_first_atempt,
                'HH:mm'
              );
        this._nihsstime =
          this.editCaseData.cas_metric_assesment_time_est == ''
            ? '00:00'
            : this.datePipe.transform(
                this.editCaseData.cas_metric_assesment_time_est,
                'HH:mm'
              );
        this._needletime =
          this.editCaseData.cas_metric_needle_time_est == ''
            ? '00:00'
            : this.datePipe.transform(
                this.editCaseData.cas_metric_needle_time_est,
                'HH:mm'
              );
        this._isCas_metric_symptom_onset_during_ed_stay =
          this.editCaseData.cas_metric_symptom_onset_during_ed_stay;
        if (
          this.editCaseData.cas_patient_type == 1 ||
          this.editCaseData.cas_patient_type == 3
        ) {
          if (this.editCaseData.cas_metric_symptom_onset_during_ed_stay) {
            this._arivaltime =
              this.editCaseData
                .cas_metric_symptom_onset_during_ed_stay_time_est == null
                ? '00:00'
                : this.datePipe.transform(
                    this.editCaseData
                      .cas_metric_symptom_onset_during_ed_stay_time_est,
                    'HH:mm'
                  );
            this.dtnorstn = 'STN';
          } else {
            this._arivaltime =
              this.editCaseData.cas_metric_door_time_est == null
                ? '00:00'
                : this.datePipe.transform(
                    this.editCaseData.cas_metric_door_time_est,
                    'HH:mm'
                  );
            this.dtnorstn = 'DTN';
          }

          this._starttoarival = parseInt(
            thrombolyticAdministrationTimelineData._starttoarival.toFixed()
          );
          this._logintodoor = parseInt(
            thrombolyticAdministrationTimelineData._logintodoor.toFixed()
          );
          this._nihsstodoor = parseInt(
            thrombolyticAdministrationTimelineData._nihsstodoor.toFixed()
          );
          this._needletodoor = parseInt(
            thrombolyticAdministrationTimelineData._needletodoor.toFixed()
          );
          this._doortoneedle = parseInt(
            thrombolyticAdministrationTimelineData._doortoneedle.toFixed()
          );
          this._arivaltovideoendtime = parseInt(
            thrombolyticAdministrationTimelineData._arivaltovideoendtime.toFixed()
          );
        } else if (
          this.editCaseData.cas_patient_type == 2 ||
          this.editCaseData.cas_patient_type == 4
        ) {
          this.workflowlabel = this.workflowtypeForTimeline;

          if (this.workflowtypeForTimeline == 'Inpatient') {
            this.labeldiagramstime = 'LKW-Time';
            this.labeldiagram = 'LTN';
            // this.datePipe.transform(
            this._lastknownwelltime =
              this.editCaseData.cas_metric_lastwell_date_est;
            //   'HH:mm'
            // );
          } else {
            this.workflowlabel = 'ED Onset';
            this.labeldiagramstime = 'STN-Time';
            this.labeldiagram = 'STN';
            this._lastknownwelltime =
              this.editCaseData
                .cas_metric_symptom_onset_during_ed_stay_time_est == null
                ? '00:00'
                : this.datePipe.transform(
                    this.editCaseData
                      .cas_metric_symptom_onset_during_ed_stay_time_est,
                    'HH:mm'
                  );
          }

          this.knownweltimetostarttime = parseInt(
            thrombolyticAdministrationTimelineData.knownweltimetostarttime.toFixed()
          );
          this.knownweltimetologintime = parseInt(
            thrombolyticAdministrationTimelineData.knownweltimetologintime.toFixed()
          );
          this.knownweltimetonihss = parseInt(
            thrombolyticAdministrationTimelineData.knownweltimetonihss.toFixed()
          );
          this.knownweltimetoneedle = parseInt(
            thrombolyticAdministrationTimelineData.knownweltimetoneedle.toFixed()
          );
        }
      }
    }
  }

  validationForRCADiagram() {
    if (this.editCaseData.cas_patient_type != null) {
      if (
        this.editCaseData.cas_patient_type == 1 ||
        this.editCaseData.cas_patient_type == 3
      ) {
        this.compareTimeForRcaDiagramActivationEMSorTriage(
          this.editCaseData.cas_patient_type
        );
      }
      if (
        this.editCaseData.cas_patient_type == 2 ||
        this.editCaseData.cas_patient_type == 4
      ) {
        this.compareTimeForRcaDiagramActivationInPatientorED(
          this.editCaseData.cas_patient_type
        );
      }
      this.compareTimeForRcaDiagramAssessment(
        this.editCaseData.cas_patient_type
      );
      this.compareTimeForRcaDiagramThrombolyticDecision(
        this.editCaseData.cas_patient_type
      );
      this.compareTimeForRcaDiagramThrombolyticAdministration(
        this.editCaseData.cas_patient_type
      );
    } else {
      this.cas_response_ts_notification_for_color = '';
      this.cas_metric_door_time_est = '';
      this.cas_metric_lastwell_date_est_for_color = '';
      this.cas_assessment_time_est_for_color = '';
      this.cas_metric_alteplase_medical_decision_for_color = '';
      this.markActivation = false;
      this.markAssesment = false;
      this.markThrombolytic = false;
      this.markThrombolyticAdmin = false;
    }
  }

  compareTimeForRcaDiagramActivationEMSorTriage(workFlowType: any) {
    if (workFlowType == 1) {
      let getDifferenceForEMS = this.getDifferenceInMinutes(
        this.cas_response_ts_notification_for_color,
        this.cas_metric_door_time_est
      );
      if (getDifferenceForEMS > 0) {
        this.markActivation = true;
      } else {
        this.markActivation = false;
      }
    } else if (workFlowType == 3) {
      let getDifferenceForEMS = this.getDifferenceInMinutes(
        this.cas_response_ts_notification_for_color,
        this.cas_metric_door_time_est
      );
      if (getDifferenceForEMS > 10) {
        this.markActivation = true;
      } else {
        this.markActivation = false;
      }
    }
  }

  compareTimeForRcaDiagramActivationInPatientorED(workFlowType: any) {
    if (workFlowType == 2 || workFlowType == 4) {
      let getDifferenceForInPatientorEDorTriage = this.getDifferenceInMinutes(
        this.cas_response_ts_notification_for_color,
        this.cas_metric_lastwell_date_est_for_color
      );
      if (getDifferenceForInPatientorEDorTriage > 10) {
        if (this.cas_metric_door_time_est != null) {
          this.markActivation = true;
        } else {
          this.markActivation = false;
        }
      } else {
        this.markActivation = false;
      }
    }
  }

  compareTimeForRcaDiagramAssessment(workFlowType: any) {
    if (workFlowType) {
      let getDifferenceForAssessmentStartTime = this.getDifferenceInMinutes(
        this.cas_assessment_time_est_for_color,
        this.cas_response_ts_notification_for_color
      );
      if (getDifferenceForAssessmentStartTime > 12) {
        this.markAssesment = true;
      } else {
        this.markAssesment = false;
      }
    }
  }

  compareTimeForRcaDiagramThrombolyticDecision(workFlowType: any) {
    if (workFlowType) {
      let getDifferenceForRCAThromboyticDecision = this.getDifferenceInMinutes(
        this.cas_metric_alteplase_medical_decision_for_color,
        this.cas_assessment_time_est_for_color
      );
      if (getDifferenceForRCAThromboyticDecision > 10) {
        this.markThrombolytic = true;
      } else {
        this.markThrombolytic = false;
      }
    }
  }

  compareTimeForRcaDiagramThrombolyticAdministration(workFlowType: any) {
    if (workFlowType) {
      // let cas_metric_needle_time_est = this.datePipe.transform(
      //   this.editCaseData.cas_metric_needle_time_est,
      //   'MM/dd/yyyy HH:mm:ss'
      // );
      // let getDifferenceForRCAThromboyticAdministration =
      //   this.getDifferenceInMinutes(
      //     cas_metric_needle_time_est,
      //     this.cas_metric_alteplase_medical_decision_for_color
      //   );
      let getDifferenceForRCAThromboyticAdministration: any;
      if (
        this.editCaseData.CustomCalculation
          .ThrombolyticAdministrationIntervalMetric
      ) {
        getDifferenceForRCAThromboyticAdministration =
          this.convertTimeToMinutes(
            this.editCaseData.CustomCalculation
              .ThrombolyticAdministrationIntervalMetric
          );
      }
      if (getDifferenceForRCAThromboyticAdministration > 8) {
        this.markThrombolyticAdmin = true;
      } else {
        this.markThrombolyticAdmin = false;
      }
    }
  }

  getDifferenceInMinutes(date1: any, date2: any) {
    if (date1 > date2) {
      return (
        Math.abs(new Date(date1).getTime() - new Date(date2).getTime()) /
        1000 /
        60
      );
    } else {
      return -1;
    }
  }

  submit(event: any) {
    if (event.includes('save')) {
      this.showProgressSpinner = true;
      this.formattingSaveData();
      this.subscription.push(
        this.analyzeService
          .submit(this.caseKey, this.formDataFinal)
          .subscribe((res) => {
            this.toastService.message('Case Data Save Successfuly.');
            if (event.toLowerCase() == 'save & close') {
              this.EditScreenBool = false;
            }
            this.getRCACountermeasuresByCaseKey(!this.EditScreenBool);
          })
      );
    } else if (
      this.caseReviewTemplateButtonName == 'Generate Review Template'
    ) {
      if (this.form.value.cas_response_MD_to_review != null) {
        if (this.form.value.cas_response_medical_director_reviewer != null) {
          if (
            this.form.value.cas_response_medical_director_reviewer.length > 0
          ) {
            this.directorListForTemplate = [];
            this.directorList.forEach((director: any) => {
              const fullName = `${director.FirstName} ${director.LastName}`;
              if (
                this.form.value.cas_response_medical_director_reviewer.includes(
                  director.Id
                )
              ) {
                this.directorListForTemplate.push(fullName);
              }
            });
          }
        }
        const element: any = document.getElementById('Director_to_Review');
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        this.showProgressSpinner = true;
        this.formattingSaveData();
        this.subscription.push(
          this.analyzeService
            .submit(this.caseKey, this.formDataFinal)
            .subscribe((res) => {
              // this.showProgressSpinner = false;
              this.getCaseDetailByCaseId(this.caseDetail, false, true);
              this.toastService.message('Case Data Save Successfuly.');
            })
        );
      } else {
        this.scrollToError();
        this.toastService.customErr(
          'Please select Medical Director to Review.'
        );
      }
    } else if (this.caseReviewTemplateButtonName == 'Load Review Template') {
      this.showProgressSpinner = true;
      this.subscription.push(
        this.analyzeService.LoadCaseReviewTemplate(this.caseKey).subscribe({
          next: (res: any) => {
            this.showProgressSpinner = false;
            this.caseReviewTemplate = res.data;
            let splitableTag =
              '<img alt="TELESPECIALISTS" src="/Content/case/pdf/logo-header.png" />';
            let splitImg = this.caseReviewTemplate.replace(
              splitableTag,
              this.img
            );
            this.caseReviewTemplate = splitImg;
            this.generateTemplatebool = true;
            if (
              this.caseReviewTemplate.includes(
                'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAABSCAYAAADuIulwAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYW'
              )
            ) {
              const pattern = /data:image\/[^;]+;base64,([^'"]+)/;
              this.caseReviewTemplate = this.caseReviewTemplate.replace(
                pattern,
                this.imgSrc
              );
            }
            if (
              this.caseReviewTemplate
                .toLowerCase()
                .includes('<li>not applicable</li>\n')
            ) {
              let splitableTag = '<li>Not Applicable</li>\n';
              let split = this.caseReviewTemplate.replace(splitableTag, '');
              this.caseReviewTemplate = split;
            }
            // if(this.TATimelineBool == false){
            //   let splitImg_TATimelineBool = `<img src="data:image/png;base64`;
            //   let splitImg_TAT = this.caseReviewTemplate.replace(
            //     splitImg_TATimelineBool,
            //     '<img '
            //   );
            //   this.caseReviewTemplate = splitImg_TAT;
            // }
          },
        })
      );
    }
  }

  scrollToError(): void {
    const firstElementWithError: any =
      this.form.value.cas_response_MD_to_review == null;
    if (firstElementWithError) {
      const element: any = document.getElementById('Director_to_Review');
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    this.Director_to_Review_bool = true;
    setTimeout(() => {
      this.Director_to_Review_bool = false;
    }, 3000);
  }

  caseReviewTemplate: any = '';
  imgSrc = ImageSources.TeleAnywhereRCALogo;
  img = `<img src='${this.imgSrc}' alt='TELESPECIALISTS' />`;
  async generateTemplate() {
    this.generateTemplatebool = true;

    this.caseReviewTemplate = `
  <!-- #region Header -->
  <div class="Section1">
      <div>
          <div>
              ${this.img}
          </div>
          <div style='font-size:14px;'>
              <b>TeleSpecialists TeleNeurology Consult Services</b>
          </div>
          <h2><b>Root Cause Analysis</b></h2>
      </div>
      <!-- #endregion Header -->

      <!-- #region Demographics -->
      <div>
          <h3 style='display:block'><b>Demographics</b></h3>`;
    if (
      this.editCaseData.facilityName != null &&
      this.editCaseData.facilityName != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
              <div style='display:block'>
                  <b>Facility: </b> ${this.editCaseData.facilityName}
              </div>`;
    }
    if (
      this.editCaseData.caseTypeName != null &&
      this.editCaseData.caseTypeName != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
              <div style='display:block'>
                  <b>Case Type: </b> ${this.editCaseData.caseTypeName} 
              </div>`;
    }
    if (
      this.editCaseData.cas_cart != null &&
      this.editCaseData.cas_cart != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
              <div style='display:block'>
                  <b>Cart: </b> ${this.editCaseData.cas_cart}
              </div>`;
    }
    if (
      this.editCaseData.cas_created_by_name != null &&
      this.editCaseData.cas_created_by_name != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
              <div style='display:block'>
                  <b>Navigator: </b>    ${this.editCaseData.cas_created_by_name}
              </div>`;
    }
    if (
      this.editCaseData.cas_case_number != null &&
      this.editCaseData.cas_case_number != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
      <div style='display:block'>
      <b>Case: </b> ${this.editCaseData.cas_case_number}
      </div>`;
    }
    if (this.caseStartTime != null && this.caseStartTime != '') {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
              <div style='display:block'>
                  <b>Start Time: </b>${this.datePipe.transform(
                    this.editCaseData.cas_response_ts_notification,
                    'HH:mm:ss'
                  )} ${this.timeZone}  ${this.datePipe.transform(
          this.editCaseData.cas_response_ts_notification,
          'MM/dd/yyyy'
        )}
                          </div>`;
    }
    if (
      this.editCaseData.cas_metric_door_time_est != null &&
      this.editCaseData.cas_metric_door_time_est != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `<div style='display:block'>
                  <b>Arrival Time: </b>${this.datePipe.transform(
                    this.editCaseData.cas_metric_door_time_est,
                    'HH:mm:ss'
                  )} ${this.timeZone}  ${this.datePipe.transform(
          this.editCaseData.cas_metric_door_time_est,
          'MM/dd/yyyy'
        )}
                          </div>`;
    }
    this.caseReviewTemplate =
      this.caseReviewTemplate +
      `
      </div>
      <!-- #endregion Demographics -->
      
      <!-- #region Assignments -->
    <div style='display:block'>
        <h3 style='display:block'><b>Assignments</b></h3>`;
    if (
      this.editCaseData.caseTypeName != null &&
      this.editCaseData.caseTypeName != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
            <div style='display:block'>
                <b>Case Type: </b> ${this.editCaseData.caseTypeName}
            </div>`;
    }
    if (
      this.workflowtypeForTimeline != null &&
      this.workflowtypeForTimeline != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
        <div style='display:block'>
        <b>Workflow Type: </b> ${this.workflowtypeForTimeline}
        </div>`;
    }
    if (
      this.editCaseData.PhysicianName != null &&
      this.editCaseData.PhysicianName != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
        <div style='display:block'>
        <b>Physician: </b> ${this.editCaseData.PhysicianName} 
        </div>`;
    }
    this.caseReviewTemplate =
      this.caseReviewTemplate +
      `
      <div style='display:block'>
      <b>Facility Requested Review: </b> N/A
      </div>`;
    if (this.editCaseData.QPSName != null && this.editCaseData.QPSName != '') {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
        <div style='display:block'>
        <b>QPS Assigned: </b> ${this.editCaseData.QPSName}
        </div>`;
    }
    if (
      this.directorListForTemplate != null &&
      this.directorListForTemplate != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
        <div style='display:block'>
        <b>Medical Director(S): </b>${this.directorListForTemplate}
        </div>`;
    }
    this.caseReviewTemplate =
      this.caseReviewTemplate +
      `
    </div>
    <!-- #endregion  Assignments-->
    
    <!-- #region Quality metrics -->
    <div>
        <h3 style='display:block'><b>Quality metrics</b></h3>`;
    if (
      this.editCaseData.cas_metric_lastwell_date_est != null &&
      this.editCaseData.cas_metric_lastwell_date_est != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
            <div style='display:block'>
            <b>Last Known Well: </b> ${this.editCaseData.cas_metric_lastwell_date_est}
            </div>`;
    }
    if (
      this.editCaseData.cas_metric_door_time_est != null &&
      this.editCaseData.cas_metric_door_time_est != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `<div style='display:block'>
                <b>Arrival Time: </b>${this.datePipe.transform(
                  this.editCaseData.cas_metric_door_time_est,
                  'HH:mm:ss'
                )} ${this.timeZone}  ${this.datePipe.transform(
          this.editCaseData.cas_metric_door_time_est,
          'MM/dd/yyyy'
        )}
                        </div>`;
    }
    if (
      this.editCaseData.CustomCalculation.ActivationTimeIntervalMetric !=
        null &&
      this.editCaseData.CustomCalculation.ActivationTimeIntervalMetric != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `<div style='display:block'>
        <!-- <b>Activation Time: </b>${
          this.editCaseData.CustomCalculation.ActivationTimeIntervalMetric
        }-->
        <b>Activation Time: </b>${this.datePipe.transform(
          this.editCaseData.cas_response_ts_notification,
          'HH:mm:ss'
        )} ${this.timeZone}  ${this.datePipe.transform(
          this.editCaseData.cas_response_ts_notification,
          'MM/dd/yyyy'
        )}
                </div>`;
    }
    if (
      this.editCaseData.cas_metric_initial_response_time_est != null &&
      this.editCaseData.cas_metric_initial_response_time_est != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
                    <div style='display:block'>
                    <b>Initial Response Time: </b>${this.datePipe.transform(
                      this.editCaseData.cas_metric_initial_response_time_est,
                      'HH:mm:ss'
                    )} ${this.timeZone}  ${this.datePipe.transform(
          this.editCaseData.cas_metric_initial_response_time_est,
          'MM/dd/yyyy'
        )}
                            </div>`;
    }
    if (
      this.editCaseData.cas_assessment_time_est != null &&
      this.editCaseData.cas_assessment_time_est != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
                      <div style='display:block'>
                      <b>Assessment Time: </b>${this.datePipe.transform(
                        this.editCaseData.cas_metric_initial_response_time_est,
                        'HH:mm:ss'
                      )} ${this.timeZone}  ${this.datePipe.transform(
          this.editCaseData.cas_metric_initial_response_time_est,
          'MM/dd/yyyy'
        )}
                              </div>`;
    }
    if (
      this.editCaseData.cas_metric_tpa_verbal_order_time_est != null &&
      this.editCaseData.cas_metric_tpa_verbal_order_time_est != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
                <div style='display:block'>
                    <b>Thrombolytic Early Mix Decision: </b>${this.datePipe.transform(
                      this.editCaseData.cas_metric_tpa_verbal_order_time_est,
                      'HH:mm:ss'
                    )} ${this.timeZone}  ${this.datePipe.transform(
          this.editCaseData.cas_metric_tpa_verbal_order_time_est,
          'MM/dd/yyyy'
        )}
                            </div>`;
    }
    if (
      this.editCaseData.cas_metric_alteplase_medical_decision != null &&
      this.editCaseData.cas_metric_alteplase_medical_decision != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
                <div style='display:block'>
                    <b>Thrombolytic Medical Decision: </b>${this.datePipe.transform(
                      this.editCaseData.cas_metric_alteplase_medical_decision,
                      'HH:mm:ss'
                    )} ${this.timeZone}  ${this.datePipe.transform(
          this.editCaseData.cas_metric_alteplase_medical_decision,
          'MM/dd/yyyy'
        )}
                </div>`;
    }
    if (this.thrombolytic_used) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
                <div style='display:block'>
                    <b>Thrombolytic Used: </b>${this.thrombolytic_used}
                </div>`;
    }
    if (
      this.editCaseData.cas_metric_needle_time_est != null &&
      this.editCaseData.cas_metric_needle_time_est != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
                <div style='display:block'>
                    <b>Needle Time: </b> ${this.datePipe.transform(
                      this.editCaseData.cas_metric_needle_time_est,
                      'MM/dd/yyyy HH:mm:ss'
                    )}
                </div>`;
    }
    if (
      this.editCaseData.cas_metric_has_morbid_symptoms != null &&
      this.editCaseData.cas_metric_has_morbid_symptoms != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
                <div style='display:block'>
                    <b>Pre-morbid MRS: </b> ${
                      this.editCaseData.cas_metric_has_morbid_symptoms == 7
                        ? 'Unable to assess'
                        : this.editCaseData.cas_metric_has_morbid_symptoms
                    }
                </div>`;
    }
    if (
      (this.editCaseData.ctai_lvo !== null &&
        this.editCaseData.ctai_lvo === 1) ||
      (this.editCaseData.ctai_lvo !== null && this.editCaseData.ctai_lvo === 0)
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
                <div style='display:block'>
                    <b>LVO: </b> ${
                      this.editCaseData.ctai_lvo === 1 ? 'Yes' : 'No'
                    }
                </div>`;
    } else {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
                <div style='display:block'>
                    <b>LVO: </b>
                    </div>`;
    }
    if (
      this.editCaseData.ctai_discussed_with_nir != null &&
      this.editCaseData.ctai_discussed_with_nir != '' &&
      this.editCaseData.ctai_lvo !== 0 &&
      this.editCaseData.ctai_lvo !== null
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
                <div style='display:block'>
                    <b>Discussed with NIR: </b> ${
                      this.editCaseData.ctai_discussed_with_nir == 1
                        ? 'Yes'
                        : 'No'
                    }
                </div>`;
    } else {
      if (
        this.editCaseData.ctai_lvo !== 0 &&
        this.editCaseData.ctai_lvo !== null
      ) {
        this.caseReviewTemplate =
          this.caseReviewTemplate +
          `
                <div style='display:block'>
                    <b>Discussed with NIR: </b>
                    </div>`;
      }
    }
    if (
      this.editCaseData.ctai_nir_discussion_time != null &&
      this.editCaseData.ctai_nir_discussion_time != '' &&
      this.editCaseData.ctai_lvo !== 0 &&
      this.editCaseData.ctai_lvo !== null
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
                <div style='display:block'>
                    <b>Discussed with NIR time: </b> ${this.datePipe.transform(
                      this.editCaseData.ctai_nir_discussion_time,
                      'MM/dd/yyyy HH:mm:ss'
                    )}
                </div>`;
    } else {
      if (
        this.editCaseData.ctai_lvo !== 0 &&
        this.editCaseData.ctai_lvo !== null
      ) {
        this.caseReviewTemplate =
          this.caseReviewTemplate +
          `
                <div style='display:block'>
                    <b>Discussed with NIR time: </b>
                </div>`;
      }
    }
    this.caseReviewTemplate =
      this.caseReviewTemplate +
      `
    </div>
    <!-- #endregion Quality metrics -->

    <!-- #region RAPIDi Interval Metrics -->
    <div>
        <h3 style='display:block'><b>RAPIDi Interval Metrics</b></h3>`;
    if (
      this.editCaseData.CustomCalculation.ActivationTimeIntervalMetric != null
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
        <div style='display:block'>
            <b>Activation Time Interval Metric: </b> ${this.editCaseData.CustomCalculation.ActivationTimeIntervalMetric}
        </div>`;
    } else {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
        <div style='display:block'>
            <b>Activation Time Interval Metric: </b>
        </div>`;
    }
    if (
      this.editCaseData.CustomCalculation.AssessmentTimeIntervalMetric !=
        null &&
      this.editCaseData.CustomCalculation.AssessmentTimeIntervalMetric != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
        <div style='display:block'>
            <b>Assessment Time Interval Metric: </b> ${this.editCaseData.CustomCalculation.AssessmentTimeIntervalMetric}
        </div>`;
    }
    if (
      this.editCaseData.CustomCalculation.ThrombolyticDecisionIntervalMetric !=
        null &&
      this.editCaseData.CustomCalculation.ThrombolyticDecisionIntervalMetric !=
        ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
        <div style='display:block'>
            <b>Thrombolytic Decision Interval Metric: </b> ${this.editCaseData.CustomCalculation.ThrombolyticDecisionIntervalMetric}
        </div>`;
    }
    if (
      this.editCaseData.CustomCalculation
        .ThrombolyticAdministrationIntervalMetric
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
        <div style='display:block'>
            <b>Thrombolytic Administration Interval Metric: </b> ${this.editCaseData.CustomCalculation.ThrombolyticAdministrationIntervalMetric}
        </div>`;
    } else {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
        <div style='display:block'>
            <b>Thrombolytic Administration Interval Metric: </b>
        </div>`;
    }
    if (
      this.initial_response_time_to_Discussed_with_NIR_time != 'NaN:NaN:NaN' &&
      this.editCaseData.ctai_lvo !== 0 &&
      this.editCaseData.ctai_lvo !== null
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
        <div style='display:block'>
            <b>Initial Response time to Discussed with NIR time: </b> ${
              !this.initial_response_time_to_Discussed_with_NIR_time
                ? ''
                : this.initial_response_time_to_Discussed_with_NIR_time
            }
        </div>`;
    }
    this.caseReviewTemplate =
      this.caseReviewTemplate +
      `
    </div>
    <!-- #endregion RAPIDi Interval Metrics -->

    <!-- #region RCA -->
    <div>
        <h3 style='display:block'><b>RCA</b>(s)</h3>`;
    if (this.SelectedNodesText.length > 0) {
      for (let index = 0; index < this.SelectedNodesText?.length; index++) {
        this.caseReviewTemplate =
          this.caseReviewTemplate +
          `
          <ul style='display:block'>
          <li>${this.SelectedNodesText[index].trim()}</li>
          </ul>`;
      }
    }
    this.caseReviewTemplate =
      this.caseReviewTemplate +
      `
      </div>
  
    <!-- #endregion RCA-->

    <!-- #region NEW AFTER RCA-->
    <div>
    <ul style='display:block'>
       <!-- #region Triage -->`;
    if (
      this.editCaseData.cas_triage_arivalstarttodelay != null &&
      this.editCaseData.cas_triage_arivalstarttodelay != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
            <li style='display:block'>${this.editCaseData.cas_triage_arivalstarttodelay}</li>`;
    }
    if (
      this.editCaseData.cas_triage_recognition != null &&
      this.editCaseData.cas_triage_recognition != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
            <li style='display:block'>${this.editCaseData.cas_triage_recognition}</li>`;
    }
    if (
      this.editCaseData.cas_triage_strokealertrigger != null &&
      this.editCaseData.cas_triage_strokealertrigger != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
            <li style='display:block'>${this.editCaseData.cas_triage_strokealertrigger}</li>`;
    }
    if (
      this.editCaseData.cas_triage_transportandrooming != null &&
      this.editCaseData.cas_triage_transportandrooming != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
            <li style='display:block'>${this.editCaseData.cas_triage_transportandrooming}</li>  `;
    }
    this.caseReviewTemplate =
      this.caseReviewTemplate +
      `
        <!-- #EndRegion Triage -->

        <!-- #region EMS -->`;
    if (
      this.editCaseData.cas_ems_arivaltostarttimedelay != null &&
      this.editCaseData.cas_ems_arivaltostarttimedelay != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
            <li style='display:block'>${this.editCaseData.cas_ems_arivaltostarttimedelay}</li>`;
    }
    if (
      this.editCaseData.cas_ems_poor_identification != null &&
      this.editCaseData.cas_ems_poor_identification != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
            <li style='display:block'>${this.editCaseData.cas_ems_poor_identification}</li>`;
    }
    if (
      this.editCaseData.cas_ems_identification_occurred != null &&
      this.editCaseData.cas_ems_identification_occurred != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
            <li style='display:block'>${this.editCaseData.cas_ems_identification_occurred}</li>`;
    }
    if (
      this.editCaseData.cas_inpatient_timefirstlogintonhssstartitme != null &&
      this.editCaseData.cas_inpatient_timefirstlogintonhssstartitme != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
            <li style='display:block'>${this.editCaseData.cas_inpatient_timefirstlogintonhssstartitme}</li>`;
    }
    this.caseReviewTemplate =
      this.caseReviewTemplate +
      `
        <!-- #End Region EMS -->
        <!-- #region Inpatient -->`;
    if (
      this.editCaseData.cas_inpatient_timefirstlogintovideostart != null &&
      this.editCaseData.cas_inpatient_timefirstlogintovideostart != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
            <li style='display:block'>${this.editCaseData.cas_inpatient_timefirstlogintovideostart}</li>`;
    }
    if (
      this.editCaseData.cas_inpatient_arivaltoneedletime != null &&
      this.editCaseData.cas_inpatient_arivaltoneedletime != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
            <li style='display:block'>${this.editCaseData.cas_inpatient_arivaltoneedletime}</li>`;
    }
    if (
      this.editCaseData.cas_inpatient_related_imaging != null &&
      this.editCaseData.cas_inpatient_related_imaging != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
            <li style='display:block'>${this.editCaseData.cas_inpatient_related_imaging}</li>`;
    }
    if (
      this.editCaseData.cas_inpatient_unenhancedct != null &&
      this.editCaseData.cas_inpatient_unenhancedct != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
            <li style='display:block'>${this.editCaseData.cas_inpatient_unenhancedct}</li>`;
    }
    if (
      this.editCaseData.cas_inpatient_telemedicineassessmentroom != null &&
      this.editCaseData.cas_inpatient_telemedicineassessmentroom != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
            <li style='display:block'>${this.editCaseData.cas_inpatient_telemedicineassessmentroom}</li>`;
    }
    if (
      this.editCaseData.cas_inpatient_telemedicineasesmentinct != null &&
      this.editCaseData.cas_inpatient_telemedicineasesmentinct != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
            <li style='display:block'>${this.editCaseData.cas_inpatient_telemedicineasesmentinct}</li>`;
    }
    if (
      this.editCaseData.cas_inpatient_bpmanagemntrelated != null &&
      this.editCaseData.cas_inpatient_bpmanagemntrelated != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
            <li style='display:block'>${this.editCaseData.cas_inpatient_bpmanagemntrelated}</li>`;
    }
    if (
      this.editCaseData.cas_inpatient_workflowbeforemixing != null &&
      this.editCaseData.cas_inpatient_workflowbeforemixing != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
            <li style='display:block'>${this.editCaseData.cas_inpatient_workflowbeforemixing}</li>`;
    }
    if (
      this.editCaseData.cas_inpatient_workflowaftermixing != null &&
      this.editCaseData.cas_inpatient_workflowaftermixing != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
            <li style='display:block'>${this.editCaseData.cas_inpatient_workflowaftermixing}</li>`;
    }
    if (
      this.editCaseData.cas_inpatient_delaysrelated_imaging != null &&
      this.editCaseData.cas_inpatient_delaysrelated_imaging != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
            <li style='display:block'>${this.editCaseData.cas_inpatient_delaysrelated_imaging}</li>`;
    }
    if (
      this.editCaseData.cas_inpatient_detection_hypertension != null &&
      this.editCaseData.cas_inpatient_detection_hypertension != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
            <li style='display:block'>${this.editCaseData.cas_inpatient_detection_hypertension}</li>`;
    }
    if (
      this.editCaseData.cas_inpatient_poormanagement_hypertension != null &&
      this.editCaseData.cas_inpatient_poormanagement_hypertension != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
            <li style='display:block'>${this.editCaseData.cas_inpatient_poormanagement_hypertension}</li>`;
    }
    if (
      this.editCaseData.cas_inpatient_tpaadministration_delays != null &&
      this.editCaseData.cas_inpatient_tpaadministration_delays != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
            <li style='display:block'>${this.editCaseData.cas_inpatient_tpaadministration_delays}</li>`;
    }
    if (
      this.editCaseData.cas_inpatient_system != null &&
      this.editCaseData.cas_inpatient_system != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
            <li style='display:block'>${this.editCaseData.cas_inpatient_system}</li>`;
    }
    if (
      this.editCaseData.cas_inpatient_physician_related != null &&
      this.editCaseData.cas_inpatient_physician_related != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
            <li style='display:block'>${this.editCaseData.cas_inpatient_physician_related}</li>`;
    }
    if (
      this.editCaseData.cas_inpatient_centralizedpharmacy_delivery != null &&
      this.editCaseData.cas_inpatient_centralizedpharmacy_delivery != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
            <li style='display:block'>${this.editCaseData.cas_inpatient_centralizedpharmacy_delivery}</li>`;
    }
    if (
      this.editCaseData.cas_inpatientdelays_mixing != null &&
      this.editCaseData.cas_inpatientdelays_mixing != ''
    ) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `
            <li style='display:block'>${this.editCaseData.cas_inpatientdelays_mixing}</li>`;
    }
    this.caseReviewTemplate =
      this.caseReviewTemplate +
      `
    </ul>
</div>

    <!-- #endregion NEW AFTER RCA-->

    <!-- #region Countermeausres -->
<div><h3><b>Countermeasure(s)</b></h3></div>
<div style="display:block;">
        <table class="table table-responsive">
            <thead>
                <tr>
                    <th style="border-bottom:1px solid black;border-left:1px solid black;border-top:1px solid black;">Root Cause</th>
                    <th style="border-bottom:1px solid black;border-left:1px solid black;border-top:1px solid black;">Countermeasure(s)</th>
                    <th style="border-bottom:1px solid black;border-left:1px solid black;border-top:1px solid black;">Responsible Party</th>
                    <th style="border-bottom:1px solid black;border-left:1px solid black;border-top:1px solid black;">Proposed Due Date</th>
                    <th style="border-bottom:1px solid black;border-left:1px solid black;border-top:1px solid black;border-right:1px solid black;">Completed Date</th>
                </tr>
            </thead>
            <tbody>`;
    for (let index = 0; index < this.RCACountermeasuresByCase.length; index++) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        ` <tr>
                        <td style="border-left:1px solid black;border-bottom:1px solid black;">${
                          this.RCACountermeasuresByCase[
                            index
                          ].rca_root_cause.trim() ?? ''
                        } </td>
                        <td style="border-left:1px solid black;border-bottom:1px solid black;"> ${
                          this.RCACountermeasuresByCase[
                            index
                          ].rca_proposed_countermeasure.replace(/</g, '&lt;') ??
                          ''
                        }</td>
                        <td style="border-left:1px solid black;border-bottom:1px solid black;"> ${
                          this.RCACountermeasuresByCase[
                            index
                          ].rca_responsible_party.replace(/</g, '&lt;') ?? ''
                        }</td>
                        <td style="border-left:1px solid black;border-bottom:1px solid black;"> ${
                          this.datePipe.transform(
                            this.RCACountermeasuresByCase[index]
                              .rca_proposed_due_date,
                            'MM/dd/yyyy'
                          ) ?? ''
                        }</td>
                        <td style="border-left:1px solid black;border-bottom:1px solid black;border-right:1px solid black;">${
                          this.datePipe.transform(
                            this.RCACountermeasuresByCase[index]
                              .rca_completed_date,
                            'MM/dd/yyyy'
                          ) ?? ''
                        }</td>
                    </tr>`;
    }

    this.caseReviewTemplate =
      this.caseReviewTemplate +
      `
           </tbody>
        </table>
  </div>
  <!-- #endregion Countermeausres -->
  
  <!-- #region Assessments(s) -->
  <div>
      <h3 style='display:block'><b>Assessments</b>(s)</h3>`;

    if (this.editCaseData.cas_response_case_qps_assessment != null) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `<div style='display:block'>
              <b>QPS Assessment: </b>${this.editCaseData.cas_response_case_qps_assessment
                .replace(/</g, '&lt;')
                .replaceAll('\n', '<br>')}
          </div>`;
    }
    if (this.editCaseData.cas_response_case_research) {
      this.caseReviewTemplate =
        this.caseReviewTemplate +
        `<div style='display:block'>
              <b>Medical Director: </b> ${this.editCaseData.cas_response_case_research
                .replace(/</g, '&lt;')
                .replaceAll('\n', '<br>')}
          </div>`;
    }
    this.caseReviewTemplate =
      this.caseReviewTemplate +
      `</div>
  
  <!-- #endregion Assessments(s) -->
`;

    // if(this.TATimelineBool == true){
    this.exportPdf();

    this.cdr.detectChanges();
    // this.caseReviewTemplate += imageHtml;
    // }
  }

  cancleTemplate() {
    this.generateTemplatebool = false;
  }
  saveTemplate() {
    let caseReviewTemplateObj = {
      cas_key: this.caseKey,
      templateData: btoa(unescape(encodeURIComponent(this.caseReviewTemplate))),
      createdById: this.helperService.decryption(
        localStorage.getItem(LocalStorage.UId)
      ),
      createdByName: this.helperService.decryption(
        localStorage.getItem(LocalStorage.UName)
      ),
    };
    this.subscription.push(
      this.analyzeService
        .SaveReviewTemplate(caseReviewTemplateObj)
        .subscribe((res) => {
          if (res.Message == 'Case Review Saved Successfully') {
            this.caseReviewTemplateButtonName = 'Load Review Template';
          }
          this.toastService.message('Case Review Template Save Successfuly.');
        })
    );
  }

  createForm() {
    this.form = this.fb.group({
      FirstName: [''],
      QPSReviewCompleted: [false],
      cas_billing_date_of_consult: [''],
      cas_metric_door_time_est: [''],
      cas_metric_stamp_time_est: [''],
      cas_metric_initial_response_time_est: [''],
      cas_response_MD_to_review: [''],
      cas_response_MD_assignment_datetime: [''],
      cas_response_case_research: [''],
      cas_response_case_qps_assessment: [''],
      cas_review_facility_communication: [''],
      cas_response_case_facility_request_reviewed: [''],
      cas_response_peer_review: [false],
      cas_response_peer_review_Physicians: [''],
      cas_response_peer_review_assignment_stamp: [''],
      cas_response_peer_review_initiated_stamp: [''],
      cas_response_peer_review_completed_stamp: [''],

      cas_response_case_qps_reviewed: [false],
      cas_case_summary_sent_to_facility: [false],
      arivaltostarttime: [''],
      assessment_to_starttime: [''],
      thrombolytic_to_assessment: [''],
      needle_to_thrombolytic: [''],
      cas_patient_type: [''],
      cas_metric_lastwell_date_est: [''],
      cas_metric_symptoms: [''],
      cas_metric_tpa_consult: [false],
      cas_is_audio_consult: [false],
      cas_nihss_cannot_completed: [false],
      cas_NIHSS_comatose: '',
      cas_NIHSS_comatose_text: [''],
      cas_assessment_time_est: [''],
      cas_metric_alteplase_medical_decision: [''],
      cas_metric_needle_time_est: [''],
      cas_metric_has_morbid_symptoms: [''],
      cas_response_reviewer: [''],
      cas_response_medical_director_reviewer: [''],
      cas_operations_review_completed: [''],
      cas_operations_review: [''],
      cas_thrombolytic_used: [''],
      PhysicianName: [''],
      ActivationTimeIntervalMetric: [''],
      AssessmentTimeIntervalMetric: [''],
      firstTimeLoginAttemtToNIHSSassTime: [''],
      ThrombolyticAdministrationIntervalMetric: [''],
      ThrombolyticDecisionIntervalMetric: [''],
      QPSName: [''],
      caseTypeName: [''],
      cas_response_operations_review_completed: [''],
      cas_review_qps_reviewed_completed: [''],
      TFLAtoNeedleTimelessThen30Minutes: [''],
      StartTimetoNeedleTimeLessThen40Minutes: [''],
      ArrivalToNeedleTime: [''],
      cas_billing_tpa_delay_notes: [''],
      cas_response_thrombolytic: [false],
      cas_response_thrombolytic_review: [''],
      ctai_lvo: [''],
      ctai_discussed_with_nir: [''],
      ctai_nir_discussion_time: [''],
      initial_response_time_to_Discussed_with_NIR_time: [''],
      cas_review_internal_notes: [''],
      cas_response_MD_review_check: [false],
    });
  }

  get f() {
    return this.form.controls;
  }

  advanceSearchForm() {
    this.advanceFormSearch = this.fb.group({
      cas_case_number: [''],
      cas_patient: [''],
      cas_advance_date: [''],
      selectedFacility: [],
      folowUp: [],
      CASEIdentificatinNumber: [''],
      selectedPhysicion: [],
      cas_eAlert: [],
      work_flow_type: [],
    });
  }

  saveCaseLeadershipReview() {
    let CaseLeadershipData: any = {};

    let keys = Object.keys(this.leaderReviewingObject);
    keys.forEach((key: any) => {
      CaseLeadershipData[key] = this.leaderReviewingObject[key];
    });

    CaseLeadershipData.clr_cas_key = this.caseKey;
    CaseLeadershipData.clr_key = 0;
    let data = this.datePipe.transform(
      CaseLeadershipData.clr_date_selected,
      'MM/dd/yyyy'
    );
    CaseLeadershipData.clr_date_selected = data;
    if (CaseLeadershipData.clr_qps_key != undefined) {
      CaseLeadershipData.clr_qps_key = CaseLeadershipData.clr_qps_key.join(',');
    }
    this.subscription.push(
      this.analyzeService
        .saveCaseLeadershipReview(this.UName, CaseLeadershipData)
        .subscribe({
          next: (res: any) => {
            if (res) {
              this.case_leadership_review = res.Data;
              this.caseLeadershipReviewDataBind();
              this.toastService.message('Leadership Review saved Successfuly.');
            }
          },
          error: (err: any) => {},
        })
    );
  }

  caseAssignmentHistoryDialog() {
    this.historyBool = true;
  }

  timeFirstLoginAttemptDialog() {
    this.TFLABool = true;
  }

  internalNotesDialog() {
    this.internalNotesBool = true;
  }

  correspondenceRecord(): FormArray {
    return this.CorrespondenceForm.get('correspondenceRecord') as FormArray;
  }

  newCorrespondenceRecord(): FormGroup {
    return this.fb.group({
      dateAndTimeOfContact: '',
      typeOfCorrespondence: '',
      comments: '',
    });
  }

  addCorrespondenceRecord() {
    this.correspondenceRecord().push(this.newCorrespondenceRecord());
  }

  removeCorrespondenceRecord(i: number) {
    this.correspondenceRecord().removeAt(i);
  }

  countermeasureRecord(): FormArray {
    return this.CounterMeasuresForm.get('counterMeasuresRecord') as FormArray;
  }

  newCountermeasureRecord(): FormGroup {
    return this.fb.group({
      rootcausevalue: '',
      propcountermsureval: '',
      responsibleprtyval: '',
      fromDate: '',
      toDate: '',
      id: '',
    });
  }

  addCountermeasureRecord() {
    this.countermeasureRecord().push(this.newCountermeasureRecord());
  }

  removeCountermeasureRecord(id: any, i: number, data: any) {
    this.messageService.clear();
    this.messageService.add({
      key: 'c',
      sticky: true,
      severity: 'custom',
      summary: 'Are you sure you want to remove this row?',
    });
    this.i = i;
    this.ide = id;
    this.backToCasesListData = data;
  }

  MedicalDirectorReview(): FormArray {
    return this.MedicalDirectorForm.get('MedicalDirectorReview') as FormArray;
  }

  newMedicalDirectorReview(): FormGroup {
    return this.fb.group({
      medicalDirectorReviewinitiated: '',
      medicalDirectorReviewCompleted: '',
    });
  }

  addMedicalDirectorReview() {
    this.MedicalDirectorReview().push(this.newMedicalDirectorReview());
  }

  removeMedicalDirectorReview(i: number) {
    this.MedicalDirectorReview().removeAt(i);
  }

  setDateAndTimeDynamically(formIndex: any, panelValue: any, fieldName: any) {
    const estTime = new Date().toLocaleString('en-US', {
      timeZone: 'America/New_York',
    });
    this.currentDate = this.datePipe.transform(estTime, 'MM/dd/yyyy HH:mm:ss');

    switch (panelValue) {
      case 'Correspondence':
        const correspondenceRecordForm = this.CorrespondenceForm.get(
          'correspondenceRecord'
        ) as FormArray;
        if (correspondenceRecordForm.at(formIndex)) {
          const contactFormGroup = correspondenceRecordForm.at(
            formIndex
          ) as FormGroup;
          contactFormGroup
            .get('dateAndTimeOfContact')
            ?.setValue(this.currentDate);
        }
        break;
      case 'Medical Director':
        const medicalDirectorReviewForm = this.MedicalDirectorForm.get(
          'MedicalDirectorReview'
        ) as FormArray;
        if (medicalDirectorReviewForm.at(formIndex)) {
          const reviewFormGroup = medicalDirectorReviewForm.at(
            formIndex
          ) as FormGroup;
          if (fieldName === 'medicalDirectorReviewinitiated') {
            reviewFormGroup
              .get('medicalDirectorReviewinitiated')
              ?.setValue(this.currentDate);
          } else if (fieldName === 'medicalDirectorReviewCompleted') {
            reviewFormGroup
              .get('medicalDirectorReviewCompleted')
              ?.setValue(this.currentDate);
          }
        }
        break;
      case 'cas_response_MD_assignment_datetime':
        this.form
          .get('cas_response_MD_assignment_datetime')
          ?.setValue(this.currentDate);
        break;
      case 'cas_response_peer_review_assignment_stamp':
        this.form
          .get('cas_response_peer_review_assignment_stamp')
          ?.setValue(this.currentDate);
        this.PreeAssignmentEst = true;
        break;
      case 'cas_response_peer_review_initiated_stamp':
        this.form
          .get('cas_response_peer_review_initiated_stamp')
          ?.setValue(this.currentDate);
        this.PreeInitiatedEst = true;
        break;
      case 'cas_response_peer_review_completed_stamp':
        this.form
          .get('cas_response_peer_review_completed_stamp')
          ?.setValue(this.currentDate);
        this.PreecompletedEst = true;
        break;
      case 'cas_review_qps_reviewed_completed':
        this.form
          .get('cas_review_qps_reviewed_completed')
          ?.setValue(this.currentDate);
        this.QpsCompletedEst = true;
        break;
      case 'cas_response_operations_review_completed':
        this.form
          .get('cas_response_operations_review_completed')
          ?.setValue(this.currentDate);
        this.OperationsCompletedEst = true;
        break;
      default:
        break;
    }
  }

  fetchMedicalDirectorReviewData() {
    this.MDReviewCompletedString = '';
    this.MDReviewinitiatedString = '';
    for (
      let index = 0;
      index < this.MedicalDirectorForm.value.MedicalDirectorReview.length;
      index++
    ) {
      this.MDReviewCompletedString = this.MDReviewCompletedString.concat(
        this.MedicalDirectorForm.value.MedicalDirectorReview[index]
          .medicalDirectorReviewCompleted
      ).concat('|');
      this.MDReviewinitiatedString = this.MDReviewinitiatedString.concat(
        this.MedicalDirectorForm.value.MedicalDirectorReview[index]
          .medicalDirectorReviewinitiated
      ).concat('|');
    }
    this.MDReviewinitiatedString = this.MDReviewinitiatedString.slice(0, -1);
    this.MDReviewCompletedString = this.MDReviewCompletedString.slice(0, -1);
  }

  fetchCorrespondenceData() {
    this.dateAndTimeOfContactString = '';
    this.typeOfCorrespondenceString = '';
    this.commentsString = '';
    for (
      let index = 0;
      index < this.CorrespondenceForm.value.correspondenceRecord.length;
      index++
    ) {
      if (
        this.CorrespondenceForm.value.correspondenceRecord[index]
          .dateAndTimeOfContact != ''
      ) {
        this.dateAndTimeOfContactString = this.dateAndTimeOfContactString
          .concat(
            this.CorrespondenceForm.value.correspondenceRecord[index]
              .dateAndTimeOfContact
          )
          .concat('Ω');
      } else {
        this.dateAndTimeOfContactString =
          this.dateAndTimeOfContactString.concat('Ω');
      }
      if (
        this.CorrespondenceForm.value.correspondenceRecord[index]
          .typeOfCorrespondence != ''
      ) {
        this.typeOfCorrespondenceString = this.typeOfCorrespondenceString
          .concat(
            this.CorrespondenceForm.value.correspondenceRecord[index]
              .typeOfCorrespondence
          )
          .concat('Ω');
      } else {
        this.typeOfCorrespondenceString =
          this.typeOfCorrespondenceString.concat('Ω');
      }

      if (
        this.CorrespondenceForm.value.correspondenceRecord[index].comments != ''
      ) {
        this.commentsString = this.commentsString
          .concat(
            this.CorrespondenceForm.value.correspondenceRecord[index].comments
          )
          .concat('Ω');
      } else {
        this.commentsString = this.commentsString.concat('Ω');
      }
    }
    this.dateAndTimeOfContactString = this.dateAndTimeOfContactString.slice(
      0,
      -1
    );
    this.typeOfCorrespondenceString = this.typeOfCorrespondenceString.slice(
      0,
      -1
    );
    this.commentsString = this.commentsString.slice(0, -1);
  }

  ToggleQPSReviewField() {
    if (
      this.form.value.cas_response_case_qps_reviewed == true ||
      this.form.value.cas_response_case_qps_reviewed == 1
    ) {
      this.QPSReviewField = true;
      this.setDateAndTimeDynamically(
        'i',
        'cas_review_qps_reviewed_completed',
        ''
      );
    } else {
      this.QPSReviewField = false;
    }
  }

  ToggleOperationsReview() {
    if (this.form.value.cas_operations_review_completed == true) {
      this.OperationsReview = true;
    } else {
      this.OperationsReview = false;
    }
  }

  cancelInternalNotes() {
    this.internalNotesBool = false;
  }

  insertInternalNotes() {
    this.internalNotesBool = false;
  }

  cancelTFLA() {
    this.TFLABool = false;
  }

  okTFLA() {
    this.TFLABool = false;
  }

  applyFilterGlobal($event: any, stringVal: any) {
    const inputValue = ($event.target as HTMLInputElement).value;
    this.dt!.filterGlobal(inputValue, stringVal);
    if (inputValue !== '') {
      this.crossSearchBool = true;
    } else {
      this.crossSearchBool = false;
    }
  }
  clearSearchField() {
    this.crossSearchBool = false;
    this.searchField = '';
    this.getAllCases('', false);
  }
  caseLeadershipReviewDataBind() {
    if (this.case_leadership_review.clr_qps_key) {
      var data = this.case_leadership_review.clr_qps_key.split(',');
    }
    this.leaderReviewingObject.clr_qps_key = data;
    if (
      this.case_leadership_review.clr_date_selected == null ||
      this.case_leadership_review.clr_date_selected == undefined
    ) {
      let clr_date_selected = this.datePipe.transform(
        new Date(),
        'MM/dd/yyyy HH:mm:ss'
      );
      this.leaderReviewingObject.clr_date_selected = clr_date_selected;
    } else {
      this.leaderReviewingObject.clr_date_selected = new Date(
        this.case_leadership_review.clr_date_selected
      );
    }

    this.leaderReviewingObject.clr_is_email_sent =
      this.case_leadership_review.clr_is_email_sent;
    this.leaderReviewingObject.clr_is_rca_completed =
      this.case_leadership_review.clr_is_rca_completed;
    this.leaderReviewingObject.clr_is_tertiary_rootcause_identified =
      this.case_leadership_review.clr_is_tertiary_rootcause_identified;
    this.leaderReviewingObject.clr_is_all_outliers_addressed =
      this.case_leadership_review.clr_is_all_outliers_addressed;
    this.leaderReviewingObject.clr_is_assessment_statement_affect =
      this.case_leadership_review.clr_is_assessment_statement_affect;
    this.leaderReviewingObject.clr_free_of_errors =
      this.case_leadership_review.clr_free_of_errors;
    this.leaderReviewingObject.clr_countermeasure_appropriate =
      this.case_leadership_review.clr_countermeasure_appropriate;
  }

  fetchHistoryTableData() {
    this.subscription.push(
      this.analyzeService.fetchHistoryTableData(this.caseKey).subscribe({
        next: (res: any) => {
          this.HistoryData = res.Data;
        },
        error: (err: any) => {},
      })
    );
  }

  RapidiIntervalMetricsConditional() {
    if (this.editCaseData.CustomCalculation._isActivationTimeIntervalMetric) {
      this.ActivationTimeIntervalMetricBool = true;
    } else {
      this.ActivationTimeIntervalMetricBool = false;
    }
    if (
      this.editCaseData.CustomCalculation
        ._isThrombolyticAdministrationIntervalMetric
    ) {
      this.ThrombolyticAdministrationIntervalMetricBool = true;
    } else {
      this.ThrombolyticAdministrationIntervalMetricBool = false;
    }
    if (
      this.editCaseData.CustomCalculation._isThrombolyticDecisionIntervalMetric
    ) {
      this.ThrombolyticDecisionIntervalMetricBool = true;
    } else {
      this.ThrombolyticDecisionIntervalMetricBool = false;
    }
    if (this.editCaseData.CustomCalculation._isAssessmentTimeIntervalMetric) {
      this.AssessmentTimeIntervalMetricBool = true;
    } else {
      this.AssessmentTimeIntervalMetricBool = false;
    }
    if (
      this.editCaseData.CustomCalculation._isTFLAToNIHStartAssessmentTime ==
      false
    ) {
      this.firstTimeLoginAttemtToNIHSSassTimeBool = true;
    } else {
      this.firstTimeLoginAttemtToNIHSSassTimeBool = false;
    }
    if (
      this.editCaseData.CustomCalculation
        ._isStartToNeedleTimeLessThen40Minutes == false
    ) {
      this.StartTimetoNeedleTimeLessThen40MinutesBool = true;
    } else {
      this.StartTimetoNeedleTimeLessThen40MinutesBool = false;
    }
    if (
      this.editCaseData.CustomCalculation
        ._isTFLAtoNeedleTimelessThen30Minutes == false
    ) {
      this.TFLAtoNeedleTimelessThen30MinutesBool = true;
    } else {
      this.TFLAtoNeedleTimelessThen30MinutesBool = false;
    }
    this.ArrivalToNeedleTimeBool = false;
    if (this.editCaseData.CustomCalculation._isArrivalToNeedleTime == false) {
      this.ArrivalToNeedleTimeBool = true;
    } else {
      this.ArrivalToNeedleTimeBool = false;
    }
  }

  patchingMedicalDirectoreModule() {
    this.ClearMedicalDirectorReview();
    if (
      this.editCaseData.cas_response_MD_review_initiated_new != null &&
      this.editCaseData.cas_response_MD_review_initiated_new != ''
    ) {
      if (this.editCaseData.cas_response_MD_review_initiated_new.length) {
        this.editCaseData.cas_response_MD_review_initiated_new =
          this.editCaseData.cas_response_MD_review_initiated_new.toString();
        this.editCaseData.cas_response_MD_review_initiated_new =
          this.editCaseData.cas_response_MD_review_initiated_new.split('|');

        for (
          let index = 0;
          index < this.editCaseData.cas_response_MD_review_initiated_new.length;
          index++
        ) {
          this.addMedicalDirectorReview();
          this.medicalDirectorBool = true;

          let medicalDirectorReviewForm: any =
            this.MedicalDirectorForm.controls['MedicalDirectorReview'];

          medicalDirectorReviewForm.controls[index].controls[
            'medicalDirectorReviewinitiated'
          ].setValue(
            // this.datePipe.transform(
            this.editCaseData.cas_response_MD_review_initiated_new[index]
            // 'MM/dd/yyyy HH:mm:ss'
            // )
          );
        }
      } else {
        this.ClearMedicalDirectorReview();
      }
    } else {
      this.ClearMedicalDirectorReview();
    }
    if (
      this.editCaseData.cas_response_medical_director_completed_new != null &&
      this.editCaseData.cas_response_medical_director_completed_new != ''
    ) {
      if (
        this.editCaseData.cas_response_medical_director_completed_new.length
      ) {
        this.editCaseData.cas_response_medical_director_completed_new =
          this.editCaseData.cas_response_medical_director_completed_new.toString();
        this.editCaseData.cas_response_medical_director_completed_new =
          this.editCaseData.cas_response_medical_director_completed_new.split(
            '|'
          );
        for (
          let index = 0;
          index <
          this.editCaseData.cas_response_medical_director_completed_new.length;
          index++
        ) {
          if (this.medicalDirectorBool == true) {
            this.addMedicalDirectorReview();
          }
          this.medicalDirectorBool = false;
          let medicalDirectorReviewForm: any =
            this.MedicalDirectorForm.controls['MedicalDirectorReview'];
          medicalDirectorReviewForm.controls[index].controls[
            'medicalDirectorReviewCompleted'
          ].setValue(
            // this.datePipe.transform(
            this.editCaseData.cas_response_medical_director_completed_new[index]
            // 'MM/dd/yyyy HH:mm:ss'
            // )
          );
        }
      } else {
        this.ClearMedicalDirectorReview();
      }
    } else {
      this.ClearMedicalDirectorReview();
    }

    if (this.MedicalDirectorForm.value.MedicalDirectorReview.length > 0) {
      const medicalDirectorReviewArray = this.MedicalDirectorForm.get(
        'MedicalDirectorReview'
      ) as FormArray;
      for (let i = medicalDirectorReviewArray.length - 1; i >= 0; i--) {
        const medicalDirectorReviewGroup = medicalDirectorReviewArray.at(
          i
        ) as FormGroup;
        const medicalDirectorReviewCompletedControl: any =
          medicalDirectorReviewGroup.get('medicalDirectorReviewCompleted');
        const medicalDirectorReviewInitiatedControl: any =
          medicalDirectorReviewGroup.get('medicalDirectorReviewinitiated');

        if (
          medicalDirectorReviewCompletedControl.value === '' &&
          medicalDirectorReviewInitiatedControl.value === ''
        ) {
          medicalDirectorReviewArray.removeAt(i);
        }
      }
    }
  }

  ClearMedicalDirectorReview() {
    const form: FormArray = this.MedicalDirectorReview();
    form.clear();
  }
  patchingCorrespondenceModule() {
    this.ClearCorrespondenceRecord();
    if (
      this.editCaseData.cas_datetime_of_contact != '' &&
      this.editCaseData.cas_datetime_of_contact != null
    ) {
      this.editCaseData.cas_datetime_of_contact =
        this.editCaseData.cas_datetime_of_contact.toString();
      this.editCaseData.cas_datetime_of_contact =
        this.editCaseData.cas_datetime_of_contact.split('{/!/}');
      for (
        let index = 0;
        index < this.editCaseData.cas_datetime_of_contact.length;
        index++
      ) {
        this.addCorrespondenceRecord();
        this.correspondenceBool = true;
        let correspondenceForm: any =
          this.CorrespondenceForm.controls['correspondenceRecord'];
        correspondenceForm.controls[index].controls[
          'dateAndTimeOfContact'
        ].setValue(
          // this.datePipe.transform(
          this.editCaseData.cas_datetime_of_contact[index]
          // 'MM/dd/yyyy HH:mm:ss')
        );
      }
    }
    if (
      this.editCaseData.cas_typeof_correspondence != '' &&
      this.editCaseData.cas_typeof_correspondence != null
    ) {
      this.editCaseData.cas_typeof_correspondence =
        this.editCaseData.cas_typeof_correspondence.toString();
      this.editCaseData.cas_typeof_correspondence =
        this.editCaseData.cas_typeof_correspondence.split(',');
      for (
        let index = 0;
        index < this.editCaseData.cas_typeof_correspondence.length;
        index++
      ) {
        if (this.correspondenceBool == false) {
          this.addCorrespondenceRecord();
        }
        if (
          this.editCaseData.cas_typeof_correspondence.length >
            this.editCaseData.cas_datetime_of_contact.length &&
          index > 0
        ) {
          this.addCorrespondenceRecord();
        }
        this.correspondenceBool = true;
        let correspondenceForm: any =
          this.CorrespondenceForm.controls['correspondenceRecord'];
        correspondenceForm.controls[index].controls[
          'typeOfCorrespondence'
        ].setValue(this.editCaseData.cas_typeof_correspondence[index]);
      }
    }
    if (
      this.editCaseData.cas_contact_comments != '' &&
      this.editCaseData.cas_contact_comments != null
    ) {
      this.editCaseData.cas_contact_comments =
        this.editCaseData.cas_contact_comments.toString();
      this.editCaseData.cas_contact_comments =
        this.editCaseData.cas_contact_comments.split('{/!/}');
      for (
        let index = 0;
        index < this.editCaseData.cas_contact_comments.length;
        index++
      ) {
        if (this.correspondenceBool == false) {
          this.addCorrespondenceRecord();
        }
        if (
          this.editCaseData.cas_contact_comments.length >
            this.editCaseData.cas_typeof_correspondence.length &&
          index > 0
        ) {
          this.addCorrespondenceRecord();
        }
        this.correspondenceBool = true;
        let correspondenceForm: any =
          this.CorrespondenceForm.controls['correspondenceRecord'];
        correspondenceForm.controls[index].controls['comments'].setValue(
          this.editCaseData.cas_contact_comments[index]
        );
      }
    }
  }

  ClearCorrespondenceRecord() {
    const form: FormArray = this.correspondenceRecord();
    form.clear();
  }
  thrombolyticRelatedComplication(boolValue: any) {
    if (boolValue == 'Yes') {
      this.thrombolyticComplicationBool = true;
    } else {
      this.thrombolyticComplicationBool = false;
    }
  }

  MedicalDirectortoReview(boolValue: any) {
    if (boolValue == 'Yes') {
      this.casResponseMDToreviewBool = true;
    } else {
      this.casResponseMDToreviewBool = false;
    }
  }
  PeerReviewRequested(boolValue: any) {
    if (boolValue == 'Yes') {
      this.PeerReviewRequestedBool = true;
    } else {
      this.PeerReviewRequestedBool = false;
    }
  }
  fetchCounterMeasuresData() {
    this.rootCauseValue = [];
    this.counterMeasureValue = [];
    this.responsiblePartyValue = [];
    this.proposedDueDateValue = [];
    this.completedDateValue = [];

    for (
      let index = 0;
      index < this.CounterMeasuresForm.value.counterMeasuresRecord.length;
      index++
    ) {
      if (
        this.CounterMeasuresForm.value.counterMeasuresRecord[index]
          .rootcausevalue != '' &&
        this.CounterMeasuresForm.value.counterMeasuresRecord[index]
          .rootcausevalue != undefined &&
        this.CounterMeasuresForm.value.counterMeasuresRecord[index]
          .rootcausevalue != null
      ) {
        this.rootCauseValue = this.rootCauseValue.concat(
          this.CounterMeasuresForm.value.counterMeasuresRecord[index]
            .rootcausevalue
        );
      }
      if (
        this.CounterMeasuresForm.value.counterMeasuresRecord[index]
          .propcountermsureval != '' &&
        this.CounterMeasuresForm.value.counterMeasuresRecord[index]
          .propcountermsureval != null &&
        this.CounterMeasuresForm.value.counterMeasuresRecord[index]
          .propcountermsureval != undefined
      ) {
        this.counterMeasureValue = this.counterMeasureValue.concat(
          this.CounterMeasuresForm.value.counterMeasuresRecord[index]
            .propcountermsureval
        );
      } else {
        this.counterMeasureValue = this.counterMeasureValue.concat('');
      }
      if (
        this.CounterMeasuresForm.value.counterMeasuresRecord[index]
          .responsibleprtyval != '' &&
        this.CounterMeasuresForm.value.counterMeasuresRecord[index]
          .responsibleprtyval != null &&
        this.CounterMeasuresForm.value.counterMeasuresRecord[index]
          .responsibleprtyval != undefined
      ) {
        this.responsiblePartyValue = this.responsiblePartyValue.concat(
          this.CounterMeasuresForm.value.counterMeasuresRecord[index]
            .responsibleprtyval
        );
      } else {
        this.responsiblePartyValue = this.responsiblePartyValue.concat('');
      }
      if (
        this.CounterMeasuresForm.value.counterMeasuresRecord[index].fromDate !=
          '' &&
        this.CounterMeasuresForm.value.counterMeasuresRecord[index].fromDate !=
          null &&
        this.CounterMeasuresForm.value.counterMeasuresRecord[index].fromDate !=
          undefined
      ) {
        this.convertedFromDate = this.datePipe.transform(
          this.CounterMeasuresForm.value.counterMeasuresRecord[index].fromDate,
          'MM/dd/yyyy'
        );
        this.proposedDueDateValue = this.proposedDueDateValue.concat(
          this.convertedFromDate
        );
      } else {
        this.proposedDueDateValue = this.proposedDueDateValue.concat(null);
      }
      if (
        this.CounterMeasuresForm.value.counterMeasuresRecord[index].toDate !=
          '' &&
        this.CounterMeasuresForm.value.counterMeasuresRecord[index].toDate !=
          null &&
        this.CounterMeasuresForm.value.counterMeasuresRecord[index].toDate !=
          undefined
      ) {
        this.convertedToDate = this.datePipe.transform(
          this.CounterMeasuresForm.value.counterMeasuresRecord[index].toDate,
          'MM/dd/yyyy'
        );
        this.completedDateValue = this.completedDateValue.concat(
          this.convertedToDate
        );
      } else {
        this.completedDateValue = this.completedDateValue.concat(null);
      }
    }
  }

  load(index: any) {
    this.loading[index] = true;
    setTimeout(() => (this.loading[index] = false), 1000);
  }

  AdvanceSearch() {
    this.advanceFormSearch.reset();
    this.advanceSearchModal = true;
  }

  backTocasesList(data: any) {
    this.showToast = true;
    if (data == 'backTocasesList') {
      this.EditScreenBool = false;
      this.showToast = false;
    } else {
      this.messageService.clear();
      this.messageService.add({
        key: 'c',
        sticky: true,
        severity: 'custom',
        summary: 'Are you sure you want to close out of this page?',
      });
    }
    this.backToCasesListData = data;
  }

  onConfirm() {
    this.showToast = false;
    if (this.backToCasesListData == 'backToCASESList') {
      this.EditScreenBool = false;
    } else if (
      this.backToCasesListData == 'removeCountermeasureRecord' &&
      this.ide
    ) {
      this.countermeasureRecord().removeAt(this.i);
      this.subscription.push(
        this.analyzeService.DeleteRCARootCause(this.ide).subscribe({
          next: (res: any) => {
            if (res.msg == 'success') {
              this.toastService.message('Data Delete Successfuly.');
            }
          },
          error: (err: any) => {},
        })
      );

      let counterMeasureIdx = this.RCACountermeasuresByCase.findIndex(
        (x: any) => x.rca_Id == this.ide
      );
      let unSelectIdx = this.unSelectArray.findIndex(
        (x: any) => x.key == this.ide
      );
      if (counterMeasureIdx != -1) {
        this.RCACountermeasuresByCase.splice(counterMeasureIdx, 1);
      }
      if (unSelectIdx != -1) {
        this.unSelectArray.splice(unSelectIdx, 1);
      }

      if (this.countermeasureRecord().value.length == 0) {
        this.counterMeasuresBool = false;
      }
    } else {
      this.countermeasureRecord().removeAt(this.i);
      let counterMeasureIdx = this.RCACountermeasuresByCase[this.i];
      this.RCACountermeasuresByCase.splice(this.i, 1);
      let unSelectIdx = this.unSelectArray.findIndex(
        (x: any) => x.key == counterMeasureIdx.rca_rootcause_id
      );
      unSelectIdx != -1 ? this.unSelectArray.splice(unSelectIdx, 1) : '';
      if (this.countermeasureRecord().value.length == 0) {
        this.counterMeasuresBool = false;
      }
    }
    this.messageService.clear();
  }

  onReject() {
    this.showToast = false;
    this.messageService.clear();
  }

  traverseAndModify(node: any) {
    node.forEach((element: any) => {
      let index = this.treeSelected.findIndex((x: any) => x.key == element.key);
      index >= 0
        ? ((element.expanded = true),
          (element.checked = true),
          element.ParentKey != null
            ? this.parentSelections.find((x: any) => x.key == element.ParentKey)
                ?.key == undefined
              ? this.parentSelections.push({ key: element.ParentKey })
              : ''
            : '')
        : ((element.expanded = false), (element.checked = false));
      if (element.children?.length > 0) {
        this.traverseAndModify(element.children);
      }
    });
  }

  AddParentCheck(node: any) {
    node.forEach((element: any) => {
      let index = this.parentSelections.findIndex(
        (x: any) => x.key == element.key
      );
      index >= 0
        ? this.parentSelections.find((x: any) => x.key == element.ParentKey)
            ?.key == undefined
          ? this.parentSelections.push({ key: element.ParentKey })
          : ''
        : '';
      if (element.children?.length > 0) {
        this.AddParentCheck(element.children);
      }
    });
  }

  traverseAndModifyPageReload(node: any) {
    node.forEach((element: any) => {
      let index = this.parentSelections.findIndex(
        (x: any) => x.key == element.key
      );
      index >= 0
        ? ((element.checked = true),
          (element.expanded = true),
          this.treeSelected.push({ key: element.key }))
        : '';
      if (element.children.length > 0) {
        this.traverseAndModifyPageReload(element.children);
      }
    });
  }

  //////////// Region FishBone Diagram //////////////////////
  SelectedIds: any;
  SelectedLabels: any;
  finalTreeSelected: any = [];
  lastChildrenArray: any = [];

  /* tree selection */
  showTreeDialog(value: any, position: any, isAgainReload: any) {
    this.parentSelections = [];
    this.PatientType = this.editCaseData.cas_patient_type;
    if (this.PatientType != null) {
      this.showProgressSpinner = true;
      switch (true) {
        case value == 'Activation' && position == 'top':
          this.cas_rcaDiagramOption = 'activation';
          this.treeLable = 'Activation';
          break;
        case value == 'Assessment Start Time' && position == 'top':
          this.cas_rcaDiagramOption = 'assessment_start_time';
          this.treeLable = 'Assessment Start Time';
          break;
        case value == 'Thrombolytic Decision' && position == 'top':
          this.cas_rcaDiagramOption = 'thrombolytic_decision';
          this.treeLable = 'Thrombolytic Decision';
          break;
        case value == 'Thrombolytic Administration' && position == 'top':
          this.cas_rcaDiagramOption = 'thrombolytic_administration';
          this.treeLable = 'Thrombolytic Administration';
          break;
      }
      this.position = position;
      this.subscription.push(
        this.treeService
          .GetRCATREEOptionValues(
            this.caseKey,
            this.PatientType,
            this.cas_rcaDiagramOption
          )
          .subscribe((res: any) => {
            if (res.Status != -2) {
              this.treeSelection = res.Data;
              this.lastChildrenArray = res.LastNodesList;
              if (this.treeSelected.length <= 0) {
                res.Data[0].data.split(',').forEach((element: any) => {
                  if (element != '') {
                    this.treeSelected.push({ key: element });
                  }
                });
                this.treeSelected = [
                  ...new Map(
                    this.treeSelected.map((item) => [item['key'], item])
                  ).values(),
                ];
              }

              switch (value.toLowerCase()) {
                case 'activation':
                  if (this.activationParentArray.length > 0) {
                    this.activationParentArray[0]
                      .split(',')
                      .forEach((element: any) => {
                        this.treeSelected.find((x: any) => x.key == element) ==
                        undefined
                          ? this.treeSelected.push({ key: element })
                          : '';
                        this.activationParentArray = [];
                      });
                  }
                  break;
                case 'assessment start time':
                  if (this.assessmentParentArray.length > 0) {
                    this.assessmentParentArray[0]
                      .split(',')
                      .forEach((element: any) => {
                        this.treeSelected.find((x: any) => x.key == element) ==
                        undefined
                          ? this.treeSelected.push({ key: element })
                          : '';
                        this.assessmentParentArray = [];
                      });
                  }
                  break;
                case 'thrombolytic decision':
                  if (this.thrombolyticDecParentArray.length > 0) {
                    this.thrombolyticDecParentArray[0]
                      .split(',')
                      .forEach((element: any) => {
                        this.treeSelected.find((x: any) => x.key == element) ==
                        undefined
                          ? this.treeSelected.push({ key: element })
                          : '';
                        this.thrombolyticDecParentArray = [];
                      });
                  }
                  break;
                case 'thrombolytic administration':
                  if (this.thrombolyticAdmParentArray.length > 0) {
                    this.thrombolyticAdmParentArray[0]
                      .split(',')
                      .forEach((element: any) => {
                        this.treeSelected.find((x: any) => x.key == element) ==
                        undefined
                          ? this.treeSelected.push({ key: element })
                          : '';
                        this.thrombolyticAdmParentArray = [];
                      });
                  }
                  break;
              }

              this.unSelectArray.forEach((element: any) => {
                let idx = this.treeSelected.findIndex(
                  (x: any) => x.key == element.key
                );
                idx >= 0 ? this.treeSelected.splice(idx, 1) : '';
              });
              this.traverseAndModify(this.treeSelection);
              if (isAgainReload) {
                for (let i = 0; i < 2; i++) {
                  this.AddParentCheck(this.treeSelection);
                }
                this.traverseAndModifyPageReload(this.treeSelection);
              }

              if (
                this.lastChildrenArray.length == 0 &&
                this.treeSelected.length > 0
              ) {
                this.treeSelected.forEach((element: any) => {
                  if (
                    element.children != undefined &&
                    element.children.length == 0
                  ) {
                    switch (value.toLowerCase()) {
                      case 'activation':
                        this.activationIds.includes(element.key)
                          ? this.lastChildrenArray.push(element)
                          : '';
                        break;
                      case 'assessment start time':
                        this.assessmentIds.includes(element.key)
                          ? this.lastChildrenArray.push(element)
                          : '';
                        break;
                      case 'thrombolytic decision':
                        this.thrombolyticDecIds.includes(element.key)
                          ? this.lastChildrenArray.push(element)
                          : '';
                        break;
                      case 'thrombolytic administration':
                        this.thrombolyticAdmIds.includes(element.key)
                          ? this.lastChildrenArray.push(element)
                          : '';
                        break;
                    }
                  }
                });
              }
              this.treeSelected = [
                ...new Map(
                  this.treeSelected.map((item) => [item['key'], item])
                ).values(),
              ];
            }
            this.showProgressSpinner = false;
            this.treeSelectionBool = true;
          })
      );
    } else {
      this.treeSelectionBool = true;
      this.position = 'top';
    }
  }

  onlyUnique(value: any, index: any, array: any) {
    return array.indexOf(value) === index;
  }

  nodeSelect(event: any) {
    if (event.node.children?.length > 0) {
      event.node.expanded = true;
      event.node.checked = true;
      let parentIdx = this.unSelectArray.findIndex(
        (x: any) => x.key == event.node.key
      );
      parentIdx >= 0 ? this.unSelectArray.splice(parentIdx, 1) : '';
    }
    if (
      event.node.parent?.children.length > 0 ||
      event.node.children.length == 0
    ) {
      /* push last select child to childrenArray */
      if (event.node.children.length == 0) {
        this.lastChildrenArray.find((x: any) => x.key == event.node.key)?.key !=
        event.node.key
          ? (this.lastChildrenArray.push({
              key: event.node.key,
              label: event.node.label,
            }),
            this.unSelectArray.findIndex((x: any) => x.key == event.node.key) !=
            -1
              ? this.unSelectArray.splice(
                  this.unSelectArray.findIndex(
                    (x: any) => x.key == event.node.key
                  ),
                  1
                )
              : '')
          : this.unSelectArray.splice(
              this.unSelectArray.findIndex((x: any) => x.key == event.node.key),
              1
            );
      }

      if (event.node.parent != undefined) {
        let parentIdx = this.unSelectArray.findIndex(
          (x: any) => x.key == event.node.parent.key
        );
        this.treeSelected.push({ key: event.node.parent.key });
        parentIdx >= 0 ? this.unSelectArray.splice(parentIdx, 1) : '';
        if (event.node.parent.parent != undefined) {
          let bgparentIdx = this.unSelectArray.findIndex(
            (x: any) => x.key == event.node.parent.parent.key
          );
          this.treeSelected.push({ key: event.node.parent.parent.key });
          bgparentIdx >= 0 ? this.unSelectArray.splice(bgparentIdx, 1) : '';
          if (event.node.parent.parent.parent != undefined) {
            let bgbgparentIdx = this.unSelectArray.findIndex(
              (x: any) => x.key == event.node.parent.parent.parent.key
            );
            this.treeSelected.push({
              key: event.node.parent.parent.parent.key,
            });
            bgbgparentIdx >= 0
              ? this.unSelectArray.splice(bgbgparentIdx, 1)
              : '';
          }
        }
      }
      event.node.checked = true;
    }

    this.treeSelected = [
      ...new Map(this.treeSelected.map((item) => [item['key'], item])).values(),
    ];

    this.finalTreeSelected = this.treeSelected
      .map((x: { key: any }) => x.key)
      .toString();
  }

  nodeUnselect(event: any) {
    this.unSelectArray.filter(this.onlyUnique);
    if (event.node.children.some((x: any) => x.expanded === true) == false) {
      this.unSelectArray.find((x: any) => x.key == event.node.key)?.key !=
      event.node.key
        ? (this.unSelectArray.push({ key: event.node.key }),
          this.lastChildrenArray.findIndex(
            (x: any) => x.key == event.node.key
          ) != -1
            ? this.lastChildrenArray.splice(
                this.lastChildrenArray.findIndex(
                  (x: any) => x.key == event.node.key
                ),
                1
              )
            : '')
        : '';
    }
    this.treeSelected = [
      ...new Map(this.treeSelected.map((item) => [item['key'], item])).values(),
    ];

    if (event.node.children.length > 0) {
      let node = event.node.children.some(
        (x: any) => x.expanded === true && x.checked === true
      );
      let childNode = event.node.children.some((x: any) => x.checked === true);
      if (node) {
        this.setTimer();
        event.node.expanded = true;
        // event.node.partialSelected = true;
        event.node.checked = true;
        this.treeSelected.find((x: any) => x.key == event.node.key)?.key !=
        event.node.key
          ? this.treeSelected.push({ key: event.node.key })
          : '';
      } else if (childNode) {
        this.setTimer();
        event.node.expanded = true;
        // event.node.partialSelected = true;
        event.node.checked = true;
        this.treeSelected.find((x: any) => x.key == event.node.key)?.key !=
        event.node.key
          ? this.treeSelected.push({ key: event.node.key })
          : '';
      } else {
        // event.node.partialSelected = false;
        event.node.expanded = false;
        event.node.checked = false;
        this.finalTreeSelected = this.treeSelected
          .map((x: { key: any }) => x.key)
          .toString();
        //this.finalTreeSelected = this.treeSelected.filter((value, index, array) => array.indexOf(value) === index)
        let index = this.treeSelected.findIndex(
          (x: any) => x.key == event.node.key
        );
        index >= 0 ? this.treeSelected.splice(index, 1) : '';
      }
    } else {
      event.node.expanded = false;
      event.node.checked = false;
      this.finalTreeSelected = this.treeSelected
        .map((x: { key: any }) => x.key)
        .toString();
    }
  }

  setTimer() {
    this.errorMessageBool = true;
    this.timer = timer(2000);
    this.subscription.push(
      this.timer.subscribe(() => {
        this.errorMessageBool = false;
      })
    );
  }

  getRCACountermeasuresByCaseKey(IsGenerateTemplateClicked: boolean = false) {
    this.subscription.push(
      this.treeService
        .getRCACountermeasuresByCaseKey(this.caseKey)
        .subscribe((res: any) => {
          this.countermeasureRecord().clear();
          this.RCACountermeasuresByCase = res.Data;
          if (
            this.RCACountermeasuresByCase != null &&
            this.RCACountermeasuresByCase != undefined
          ) {
            if (this.RCACountermeasuresByCase.length > 0) {
              this.counterMeasuresBool = true;
            } else {
              this.counterMeasuresBool = false;
            }
            for (
              let index = 0;
              index < this.RCACountermeasuresByCase.length;
              index++
            ) {
              this.addCountermeasureRecord();
              let counterMeasuresForm: any =
                this.CounterMeasuresForm.controls['counterMeasuresRecord'];
              counterMeasuresForm.controls[index].controls[
                'rootcausevalue'
              ].setValue(this.RCACountermeasuresByCase[index].rca_root_cause);

              counterMeasuresForm.controls[index].controls[
                'propcountermsureval'
              ].setValue(
                this.RCACountermeasuresByCase[index].rca_proposed_countermeasure
              );

              counterMeasuresForm.controls[index].controls[
                'responsibleprtyval'
              ].setValue(
                this.RCACountermeasuresByCase[index].rca_responsible_party
              );

              counterMeasuresForm.controls[index].controls['fromDate'].setValue(
                this.RCACountermeasuresByCase[index].rca_proposed_due_date
              );

              counterMeasuresForm.controls[index].controls['toDate'].setValue(
                this.RCACountermeasuresByCase[index].rca_completed_date
              );
              counterMeasuresForm.controls[index].controls['id'].setValue(
                this.RCACountermeasuresByCase[index].rca_Id
              );
            }
          }
          IsGenerateTemplateClicked ? '' : (this.showProgressSpinner = false);
        })
    );
  }

  closeRCADiagramPopUp() {
    let diagramId = this.treeLable.replace(/ /g, '_').toLowerCase();
    this.updateFishBoneDiagram(diagramId, false);
  }

  showCounterMeasures() {
    this.treeSelectionBool = false;
    this.closeRCADiagramPopUp();
    for (
      let indexTree = 0;
      indexTree < this.lastChildrenArray.length;
      indexTree++
    ) {
      let cntIdx = this.RCACountermeasuresByCase.filter(
        (x: any) =>
          x.rca_root_cause.trim() ==
          this.lastChildrenArray[indexTree].label.trim()
      );

      if (this.lastChildrenArray[indexTree].label != undefined) {
        if (cntIdx.length == 0) {
          this.RCACountermeasuresByCase.push({
            rca_rootcause_id: this.lastChildrenArray[indexTree].key,
            rca_root_cause: this.lastChildrenArray[indexTree].label,
          });
        }

        // this.CounterMeasuresForm = this.fb.group({
        //   counterMeasuresRecord: this.fb.array([]),
        // });
        for (
          let index = 0;
          index < this.RCACountermeasuresByCase.length;
          index++
        ) {
          if (
            !this.CounterMeasuresForm.value.counterMeasuresRecord.some(
              (x: any) =>
                x.rootcausevalue.trim() ==
                this.RCACountermeasuresByCase[index].rca_root_cause.trim()
            )
          ) {
            this.addCountermeasureRecord();
            let targetIndex =
              this.CounterMeasuresForm.value.counterMeasuresRecord.findIndex(
                (x: any) => x.rootcausevalue === ''
              );
            let counterMeasuresForm: any =
              this.CounterMeasuresForm.controls['counterMeasuresRecord'];
            counterMeasuresForm.controls[targetIndex].controls[
              'rootcausevalue'
            ].setValue(this.RCACountermeasuresByCase[index].rca_root_cause);

            counterMeasuresForm.controls[targetIndex].controls[
              'propcountermsureval'
            ].setValue(
              this.RCACountermeasuresByCase[index].rca_proposed_countermeasure
            );

            counterMeasuresForm.controls[targetIndex].controls[
              'responsibleprtyval'
            ].setValue(
              this.RCACountermeasuresByCase[index].rca_responsible_party
            );

            counterMeasuresForm.controls[targetIndex].controls[
              'fromDate'
            ].setValue(
              this.RCACountermeasuresByCase[index].rca_proposed_due_date
            );

            counterMeasuresForm.controls[targetIndex].controls[
              'toDate'
            ].setValue(this.RCACountermeasuresByCase[index].rca_completed_date);

            counterMeasuresForm.controls[targetIndex].controls['id'].setValue(
              this.RCACountermeasuresByCase[index].rca_Id
            );
          }
        }
      }
    }
    if (this.unSelectArray.length > 0) {
      for (let index = 0; index < this.unSelectArray.length; index++) {
        let indexOF: any = -1;
        for (let i = 0; i < this.RCACountermeasuresByCase.length; i++) {
          if (
            this.RCACountermeasuresByCase[i].rca_rootcause_id ==
              this.unSelectArray[index].key &&
            this.RCACountermeasuresByCase[i].rca_Id == undefined
          ) {
            indexOF = i;
            break;
          }
        }
        if (indexOF != -1) {
          this.RCACountermeasuresByCase.splice(indexOF, 1);
          this.CounterMeasuresForm = this.fb.group({
            counterMeasuresRecord: this.fb.array([]),
          });
          for (
            let index = 0;
            index < this.RCACountermeasuresByCase.length;
            index++
          ) {
            this.addCountermeasureRecord();
            let counterMeasuresForm: any =
              this.CounterMeasuresForm.controls['counterMeasuresRecord'];
            counterMeasuresForm.controls[index].controls[
              'rootcausevalue'
            ].setValue(this.RCACountermeasuresByCase[index].rca_root_cause);

            counterMeasuresForm.controls[index].controls[
              'propcountermsureval'
            ].setValue(
              this.RCACountermeasuresByCase[index].rca_proposed_countermeasure
            );

            counterMeasuresForm.controls[index].controls[
              'responsibleprtyval'
            ].setValue(
              this.RCACountermeasuresByCase[index].rca_responsible_party
            );

            counterMeasuresForm.controls[index].controls['fromDate'].setValue(
              this.RCACountermeasuresByCase[index].rca_proposed_due_date
            );

            counterMeasuresForm.controls[index].controls['toDate'].setValue(
              this.RCACountermeasuresByCase[index].rca_completed_date
            );
            if (this.RCACountermeasuresByCase.length > 0) {
              this.counterMeasuresBool = true;
            }
          }
        }
      }
    }

    if (this.RCACountermeasuresByCase.length > 0) {
      this.counterMeasuresBool = true;
    } else {
      this.counterMeasuresBool = false;
    }
  }

  formattingSaveData() {
    this.fetchMedicalDirectorReviewData();
    this.fetchCorrespondenceData();
    this.fetchCounterMeasuresData();
    this.cas_review_qps_reviewed_completed = this.datePipe.transform(
      this.form.value.cas_review_qps_reviewed_completed,
      'MM/dd/yyyy HH:mm:ss'
    );
    this.cas_response_MD_assignment_datetime = this.datePipe.transform(
      this.form.value.cas_response_MD_assignment_datetime,
      'MM/dd/yyyy HH:mm:ss'
    );
    this.cas_response_peer_review_assignment_stamp = this.datePipe.transform(
      this.form.value.cas_response_peer_review_assignment_stamp,
      'MM/dd/yyyy HH:mm:ss'
    );
    this.cas_response_peer_review_initiated_stamp = this.datePipe.transform(
      this.form.value.cas_response_peer_review_initiated_stamp,
      'MM/dd/yyyy HH:mm:ss'
    );
    this.cas_response_peer_review_completed_stamp = this.datePipe.transform(
      this.form.value.cas_response_peer_review_completed_stamp,
      'MM/dd/yyyy HH:mm:ss'
    );
    this.cas_response_operations_review_completed = this.datePipe.transform(
      this.form.value.cas_response_operations_review_completed,
      'MM/dd/yyyy HH:mm:ss'
    );
    if (this.RCACountermeasuresByCase.length > 0) {
      for (
        let index = 0;
        index < this.RCACountermeasuresByCase.length;
        index++
      ) {
        this.rootCauseIdsValue.push(
          this.RCACountermeasuresByCase[index].rca_rootcause_id
        );
        const rootCauseIdsValue = this.rootCauseIdsValue.map((num: any) => {
          return String(num);
        });
        this.rootCauseIdsValue = rootCauseIdsValue;
      }
    }
    if (this.form.value.cas_response_thrombolytic == true) {
      this.form.value.cas_response_thrombolytic = 1;
    } else {
      this.form.value.cas_response_thrombolytic = 2;
    }
    if (this.form.value.cas_response_thrombolytic_review == '') {
      this.form.value.cas_response_thrombolytic_review = 0;
    }
    this.formDataFinal = {
      cas_billing_date_of_consult:
        this.form.value.cas_billing_date_of_consult.toDateString(),
      cas_billing_tpa_delay_notes: this.form.value.cas_billing_tpa_delay_notes,
      cas_response_thrombolytic: this.form.value.cas_response_thrombolytic,
      cas_response_thrombolytic_review:
        this.form.value.cas_response_thrombolytic_review,
      cas_response_reviewer: this.form?.value.cas_response_reviewer?.toString(),
      cas_response_MD_assignment_datetime:
        this.cas_response_MD_assignment_datetime,
      cas_response_MD_to_review: this.form.value.cas_response_MD_to_review,
      cas_response_medical_director_reviewer:
        this.form.value.cas_response_medical_director_reviewer?.toString(),
      cas_response_case_research: this.form.value.cas_response_case_research,
      cas_response_case_qps_assessment:
        this.form.value.cas_response_case_qps_assessment,
      cas_review_facility_communication:
        this.form.value.cas_review_facility_communication,
      cas_response_case_facility_request_reviewed:
        this.form.value.cas_response_case_facility_request_reviewed,
      cas_response_peer_review: this.form.value.cas_response_peer_review,
      cas_response_peer_review_Physicians:
        this.form.value.cas_response_peer_review_Physicians?.toString(),
      cas_response_peer_review_assignment_stamp:
        this.cas_response_peer_review_assignment_stamp,
      cas_response_peer_review_initiated_stamp:
        this.cas_response_peer_review_initiated_stamp,
      cas_response_peer_review_completed_stamp:
        this.cas_response_peer_review_completed_stamp,
      cas_response_case_qps_reviewed:
        this.form.value.cas_response_case_qps_reviewed,
      cas_case_summary_sent_to_facility:
        this.form.value.cas_case_summary_sent_to_facility,
      cas_review_qps_reviewed_completed: this.cas_review_qps_reviewed_completed,
      cas_operations_review_completed:
        this.form.value.cas_operations_review_completed,
      cas_operations_review: this.form.value.cas_operations_review,
      cas_response_operations_review_completed:
        this.cas_response_operations_review_completed,
      cas_response_medical_director_completed_new: this.MDReviewCompletedString,
      cas_response_MD_review_initiated_new: this.MDReviewinitiatedString,
      cas_datetime_of_contact: this.dateAndTimeOfContactString,
      cas_typeof_correspondence: this.typeOfCorrespondenceString,
      cas_contact_comments: this.commentsString,
      cas_review_internal_notes: this.internalNotes,
      cas_response_MD_review_check: this.reviewCompletedBool,
      cas_work_flow_ids:
        this.finalTreeSelected.toString() == '' &&
        this.unSelectArray.length == 0
          ? this.editCaseData.cas_work_flow_ids // ? '':this.editCaseData.cas_work_flow_ids ?? ''
          : this.finalTreeSelected.toString(),
      rootCauseIdsValue: this.rootCauseIdsValue,
      rootcausevalue: this.rootCauseValue,
      counterMeasureValue: this.counterMeasureValue,
      responsiblePartyValue: this.responsiblePartyValue,
      proposedDueDateValue: this.proposedDueDateValue,
      completedDateValue: this.completedDateValue,
    };
  }

  updateFishBoneDiagram(optionId: any, isAgainReload: any = true) {
    if (optionId == 'activation') {
      this.showRCAFishBoneDiagram(
        'activation',
        'RCAFishBoneJSTreeforActivation',
        isAgainReload
      );
    }
    if (optionId == 'assessment_start_time') {
      this.showRCAFishBoneDiagram(
        'assessment_start_time',
        'RCAFishBoneJSTreeforAssessment',
        isAgainReload
      );
    }
    if (optionId == 'thrombolytic_decision') {
      this.showRCAFishBoneDiagram(
        'thrombolytic_decision',
        'RCAFishBoneJSTreeforTD',
        isAgainReload
      );
    }
    if (optionId == 'thrombolytic_administration') {
      this.showRCAFishBoneDiagram(
        'thrombolytic_administration',
        'RCAFishBoneJSTreeforTA',
        isAgainReload
      );
    }
  }

  async loadFishBoneDiagram(IsGenerateTemplateClicked: boolean) {
    await this.showRCAFishBoneDiagram(
      'activation',
      'RCAFishBoneJSTreeforActivation'
    );
    await this.showRCAFishBoneDiagram(
      'assessment_start_time',
      'RCAFishBoneJSTreeforAssessment'
    );
    await this.showRCAFishBoneDiagram(
      'thrombolytic_decision',
      'RCAFishBoneJSTreeforTD'
    );
    await this.showRCAFishBoneDiagram(
      'thrombolytic_administration',
      'RCAFishBoneJSTreeforTA'
    );
    IsGenerateTemplateClicked ? this.generateTemplate() : '';
  }

  activationIds: any;
  assessmentIds: any;
  thrombolyticDecIds: any;
  thrombolyticAdmIds: any;
  showRCAFishBoneDiagram(
    RcaDiagramOption: any,
    fishBoneId: any,
    isAgainReload: any = true
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      let patientType = this.editCaseData.cas_patient_type;
      this.subscription.push(
        this.treeService
          .GetFishBoneDiagramValues(this.caseKey, patientType, RcaDiagramOption)
          .subscribe({
            next: (res: any) => {
              this.RCADataForTemplate = res.Data;
              this.RCAFishBoneFileTree(
                res.Data,
                RcaDiagramOption,
                fishBoneId,
                isAgainReload
              );
              switch (RcaDiagramOption.toLowerCase()) {
                case 'activation':
                  this.activationIds = this.GetRCAOptionIds(res.Data);
                  break;
                case 'assessment_start_time':
                  this.assessmentIds = this.GetRCAOptionIds(res.Data);
                  break;
                case 'thrombolytic_decision':
                  this.thrombolyticDecIds = this.GetRCAOptionIds(res.Data);
                  break;
                case 'thrombolytic_administration':
                  this.thrombolyticAdmIds = this.GetRCAOptionIds(res.Data);
                  break;
              }
              resolve();
            },
            error: (err: any) => {
              reject();
            },
          })
      );
    });
  }

  GetRCAOptionIds(value: any): any {
    let sepvalue: any = '';
    value.forEach((element: any) => {
      sepvalue += element.id + ',';
    });
    return sepvalue;
  }

  RCAFishBoneFileTree(
    FileTreeValues: any,
    RcaDiagramOption: any,
    fishBoneId: any,
    isAgainReload: any = true
  ) {
    if (!isAgainReload) {
      this.finalTreeSelected = this.treeSelected.map(
        (x: { key: any }) => x.key
      );
    }

    $('#' + fishBoneId)
      .jstree('destroy')
      .empty();
    $('#' + fishBoneId).jstree({
      core: {
        data: FileTreeValues,
        themes: {
          icons: false,
        },
      },
      checkbox: {
        three_state: false,
        cascade: 'none',
      },
      plugins: ['themes', 'wholerow', 'checkbox'],
    });

    let Ids = [];
    if (
      this.editCaseData.cas_work_flow_ids &&
      this.editCaseData.cas_work_flow_ids.length > 0 &&
      isAgainReload
    ) {
      Ids = this.editCaseData.cas_work_flow_ids.split(',');
    }
    if (
      this.finalTreeSelected.length > 0 &&
      this.finalTreeSelected.length > Ids.length
    ) {
      Ids = this.finalTreeSelected.includes(',')
        ? this.finalTreeSelected.split(',')
        : this.finalTreeSelected;
    }

    Ids.map((data: any) => {
      let id: any;
      if (data.key != undefined) {
        id = parseInt(data.key);
      } else {
        id = parseInt(data);
      }
      this.checkTreeNodes(fishBoneId, id);
    });
    this.hideUnSelectedNodes(fishBoneId, RcaDiagramOption, isAgainReload);
    Ids.map((data: any) => {
      let id: any;
      if (data.key != undefined) {
        id = parseInt(data.key);
      } else {
        id = parseInt(data);
      }
      this.uncheckTreeNodes(fishBoneId, id);
    });
    $('#' + fishBoneId).off('dblclick').on('dblclick', '.jstree-anchor', function (e) {
      e.stopImmediatePropagation();
      e.preventDefault();
      return false;
    });

    switch (RcaDiagramOption) {
      case 'activation':
        $('#' + fishBoneId).show();
        break;
      case 'assessment_start_time':
        $('#' + fishBoneId).show();
        break;
      case 'thrombolytic_decision':
        $('#' + fishBoneId).show();
        break;
      case 'thrombolytic_administration':
        $('#' + fishBoneId).show();
        break;
    }
  }

  checkTreeNodes(treeid: any, nodeid: any) {
    let tree = $('#' + treeid);
    tree
      .on('ready.jstree', function (e, data) {
        tree.jstree(true).check_node(nodeid, '');
        tree.jstree(true).open_node(nodeid, '');
      })
      .jstree();
  }

  hideUnSelectedNodes(
    fishBoneId: any,
    RcaDiagramOption: any,
    isAgainReload: any = true
  ) {
    let tree = $('#' + fishBoneId);
    tree.on('ready.jstree', (e, data) => {
      let nodesSelected = tree.jstree(true).get_selected(),
        nodeIdsToStay: any = [];

      nodesSelected.forEach((node) => {
        let path = tree.jstree(true).get_path(node, ',', true).split(',');
        switch (RcaDiagramOption) {
          case 'activation':
            this.activationParentArray = [];
            this.activationParentArray.unshift(path.toString());
            break;
          case 'assessment_start_time':
            this.assessmentParentArray = [];
            this.assessmentParentArray.unshift(path.toString());
            break;
          case 'thrombolytic_decision':
            this.thrombolyticDecParentArray = [];
            this.thrombolyticDecParentArray.unshift(path.toString());
            break;
          case 'thrombolytic_administration':
            this.thrombolyticAdmParentArray = [];
            this.thrombolyticAdmParentArray.unshift(path.toString());
            break;
        }
        path.forEach(function (n: any) {
          if (nodeIdsToStay.indexOf(n) === -1) {
            nodeIdsToStay.push(n);
          }
        });
      });

      $('#' + fishBoneId)
        .find('li')
        .each(function () {
          if (nodeIdsToStay.indexOf(this.id) === -1) {
            $(this).hide();
          }
        });

      $('#' + fishBoneId + ' li.jstree-node').each(function () {
        $('#' + fishBoneId).jstree('disable_node', this.id);
      });

      $('#' + fishBoneId + ' i.jstree-ocl')
        .off('click.block')
        .on('click.block', function () {
          return false;
        });
    });
  }

  uncheckTreeNodes(treeid: any, nodeid: any) {
    let tree = $('#' + treeid);
    tree
      .on('ready.jstree', function (e, data) {
        tree.jstree(true).uncheck_node(nodeid, '');
        tree.jstree(true).disable_node(nodeid);
      })
      .jstree();
  }

  ////////// Region FishBone Diagram End//////////////////////
  // async exportPdf(): Promise<void> {
  //   try {
  //     this.mainRCADiagramFCRT = true;
  //     this.cdr.detectChanges();
  //     let DATA: any = document.getElementById('circleDiagramTree');
  //     const canvas = await html2canvas(DATA, { scale: 1 });
  //     const imgSrc = canvas.toDataURL('image/png', 0.9);
  //     this.mainRCADiagramFCRT = false;
  //     this.caseReviewTemplate += `<img src="${imgSrc}" title="Thrombolytic Timeline">`;
  //   } catch (error) {
  //     console.error(error);
  //   }
  // }

  async exportPdf(): Promise<void> {
    try {
      this.mainRCADiagramFCRT = true;
      let DATA: any = document.getElementById('circleDiagramTree');
      const img = await domtoimage.toPng(DATA);
      this.mainRCADiagramFCRT = false;
      const imgElement = document.createElement('img');
      imgElement.src = img;
      imgElement.title = 'Thrombolytic Timeline';

      this.caseReviewTemplate += imgElement.outerHTML;

      this.showProgressSpinner = false;
    } catch (error) {
      console.error(error);
    }
  }

  exportToWordCaseReviewTemplate() {
    let innerdocbody: any;
    innerdocbody = this.caseReviewTemplate;

    innerdocbody = innerdocbody.replace(
      '/Content/case/pdf/logo-header.png',
      'https://dev-telecare.condadocloud.net/Content/images/logo-header.png'
    );
    let header =
      "<html xmlns:o='urn:schemas-microsoft-com:office:office' " +
      "xmlns:w='urn:schemas-microsoft-com:office:word' " +
      "xmlns='http://www.w3.org/TR/REC-html40'>" +
      "<head><meta charset='utf-8'><title>Case Review</title><style>@@Page Section1{margin:0.70in 1in 0.70in 1in;} div.Section1 {page: Section1}</style></head><body>";
    let footer = '</body></html>';
    let sourceHTML = header + innerdocbody + footer;
    let source =
      'data:application/vnd.ms-word;charset=utf-8,' +
      encodeURIComponent(sourceHTML);
    let fileDownload = document.createElement('a');
    document.body.appendChild(fileDownload);
    fileDownload.href = source;
    fileDownload.download = 'CaseReviewTemplate.doc';
    fileDownload.click();
    document.body.removeChild(fileDownload);
  }
  CheckTextbox($event: any) {
    let val = ($event.target as HTMLInputElement).value;
    if (val != this.editCaseData.cas_review_internal_notes && val != '') {
      this.internalNotesSaveBool = false;
    } else {
      this.internalNotesSaveBool = true;
    }
  }

  excelDownload(workbook: any, fileName: any) {
    workbook.xlsx.writeBuffer().then((data: any) => {
      let blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      FileSaver.saveAs(blob, fileName + '.xlsx');
    });
  }

  exportExcel() {
    this.excelBool = true;
    this.checkEmptyFields();
    this.exportExcelLoader = true;
    let newArray: any = [];
    let cases: any = [];
    this.subscription.push(
      this.analyzeService
        .getAllCases(this.RoleName, this.UId, this.data)
        .subscribe({
          next: (res: any) => {
            if (res.data.length == 0) {
              this.noRecordBool = true;
            } else {
              this.noRecordBool = false;
            }
            if (res) {
              cases = res.data;
              if (cases.length > 0) {
                cases.forEach((item: any) => {
                  let caseStatus = this.statusList.filter((x: any) => {
                    return x.value == item.CaseStatus;
                  });
                  if (caseStatus.length > 0) {
                    item.caseStatusLabel = caseStatus[0].name;
                  }
                  let time: any;
                  if (item.CaseStartTime) {
                    time = this.datePipe.transform(
                      item.CaseStartTime,
                      'MM/dd/yyyy HH:mm:ss'
                    );
                  }

                  newArray.push({
                    CASENumber: item.CASENumber,
                    cas_is_audio_consult: item.cas_is_audio_consult
                      ? 'Yes'
                      : 'No',
                    CASEIdentificatinNumber: item.CASEIdentificatinNumber,
                    FacilityName: item.FacilityName,
                    PatientDOB: new Date(item.PatientDOB).toLocaleDateString(
                      'en-US'
                    ),
                    cas_metric_tpa_consult: item.cas_metric_tpa_consult
                      ? 'Yes'
                      : 'No',
                    CaseType: item.CaseType,
                    PhysicianName: item.PhysicianName,
                    caseStatusLabel: item.caseStatusLabel,
                    QPSReviewCompleted:
                      (item.caseStatusLabel === 'Stroke Alert' ||
                        item.caseStatusLabel === 'Stroke Alert') &&
                      item.QPSReviewCompleted == 1
                        ? 'Yes'
                        : '',
                    CaseStartTime: time,
                    PatientName: item.PatientName,
                  });
                });
              }

              let dataForExcel: any = [];
              let workbook = new Workbook();
              let worksheet = workbook.addWorksheet('Sheet1', {
                properties: {
                  tabColor: { argb: '36286B' },
                  outlineLevelRow: 1,
                },
              });
              worksheet.columns = [
                { header: 'Case No', key: 'case no', width: 15 },
                { header: 'AudioOnly', key: 'AudioOnly', width: 20 },
                { header: 'Patient ID', key: 'Patient ID', width: 15 },
                { header: 'Facility', key: 'Facility', width: 90 },
                { header: 'Patient DOB', key: 'Patient DOB', width: 90 },
                {
                  header: 'Lytic Candidate',
                  key: 'Lytic Candidate',
                  width: 90,
                },
                { header: 'Type', key: 'Type', width: 20 },
                { header: 'Physician', key: 'Physician ', width: 25 },
                { header: 'Case Status', key: 'Case Status', width: 20 },
                {
                  header: 'QPS Review Completed',
                  key: 'QPS Review Completed',
                  width: 20,
                },
                { header: 'Start time', key: 'Start time', width: 25 },
                { header: 'Patient name', key: 'Patient name', width: 25 },
              ];
              worksheet.eachRow(
                { includeEmpty: true },
                function (row, rowNumber) {
                  row.eachCell((cell, number) => {
                    cell.fill = {
                      type: 'pattern',
                      pattern: 'solid',
                      fgColor: { argb: '767C88' },
                      bgColor: { argb: '' },
                    };
                    cell.font = {
                      bold: true,
                      color: { argb: 'FFFFFF' },
                      size: 12,
                    };
                  });
                }
              );

              if (this.roleForFacility) {
                worksheet.getColumn('Case Status').hidden = true;
                worksheet.getColumn('QPS Review Completed').hidden = true;
              }
              newArray.forEach((element: any) => {
                dataForExcel.push(Object.values(element));
              });

              dataForExcel.forEach((d: any) => {
                let row = worksheet.addRow(d);
              });
              this.excelDownload(workbook, 'Cases RCA');
              this.exportExcelLoader = false;
            }
          },
          error: (err: any) => {},
        })
    );
  }
  onContextMenu(event: MouseEvent, cases: any, bool: any) {
    event.preventDefault();
    const queryParams = {
      getCaseDetail: true,
      editScreen: true,
      caseKey: cases.CaseKey,
      caseStatus: cases.CaseStatus,
      caseStartTime: cases.CaseStartTime,
      screenStatus: bool,
      SelectedCaseEdit: JSON.stringify(cases),
    };
    const navigationExtras: NavigationExtras = {
      queryParams,
    };

    const url = this.router.createUrlTree(
      ['Home/Analyze/Cases'],
      navigationExtras
    );
    window.open(url.toString(), '_blank');
  }

  onContextMenuPreventDefault(event: any) {
    event.preventDefault();
  }

  GetFacilityContact(event: any) {
    this.sharebtnLoader = true;
    this.showProgressSpinner = true;
    let model = {
      Facility: this.editCaseData.cas_fac_key,
      System: null,
    };
    this.analyzeService.GetUserByFacility(model).subscribe({
      next: (res: any) => {
        this.shareImprove = [];
        res.data.forEach((value: any) => {
          let shareKeys: any = Object.keys(value);
          let sb: any = [];
          shareKeys.forEach((item: any, index: any) => {
            if (
              item.includes('Name') &&
              value[item] != null &&
              !item.includes('fpigi_facility_Name')
            ) {
              sb.push({ [shareKeys[index]]: value[shareKeys[index]] });
              sb.push({ [shareKeys[index + 1]]: value[shareKeys[index + 1]] });
              sb.push({ [shareKeys[index + 2]]: value[shareKeys[index + 2]] });
            }
          });
          let myArr: any = [];
          let label: any;
          sb.forEach((element: any, index: any) => {
            if (index % 3 == 0) {
              myArr = sb.slice(index, index + 3);
              let obj = myArr.flatMap((d: any) => Object.values(d)[0]);
              label = Object.keys(myArr[0])[0].split('_');
              label.shift();
              label.pop();
              label = label.join(' ');
              label = label.replace(/\b\w/g, (l: any) => l.toUpperCase());
              this.shareImprove.push({
                name: obj[0],
                phone: obj[1],
                email: obj[2],
                label: label,
              });
            }
          });
        });
        this.shareImprove?.forEach((element: any) => {
          element['isSelected'] = false;
          switch (element.label) {
            case 'Primary AccountingManager':
              element.label = 'Accounting Manager';
              break;
            case 'Primary Controller':
              element.label = 'Controller';
              break;
            case 'Medical Records Deficiencies Contact':
              element.label = 'MD.Records (Deficiencies) CP';
              break;
            case 'President Or Ceo':
              element.label = 'President Or CEO';
              break;
          }
        });
        this.displayModal = true;
        this.showProgressSpinner = false;
        this.sharebtnLoader = false;
        this.masterSelected = undefined;
        this.checkedList = [];
      },
      error: (err: any) => {},
    });
  }

  GetEmaiRcaFacility(value: any) {
    if (value == 'btn') {
      this.selectedOptionText = true;
      this.sharedReportLoader = true;
    }

    this.showsharedProgressSpinner = true;
    this.analyzeService
      .GetEmailRcaFacility(this.facilityName, this.take, this.skip)
      .subscribe({
        next: (res: any) => {
          this.sharedReportLoader = false;
          this.showsharedProgressSpinner = false;
          this.facilityMailData = res.data;
          this.totalRecords = res?.data[0]?.TOTALRECORDS;
          if (this.facilityMailData.length > 0) {
            this.facilityMailData.forEach((element: any) => {
              element.qitsd_created_by_date = this.datePipe.transform(
                element.qitsd_created_by_date,
                'MM/dd/yyyy HH:mm:ss'
              );
            });
            this.noRecordFoundBool = false;
          } else {
            this.noRecordFoundBool = true;
          }
          this.displayBasic2 = true;
        },
      });
  }

  async getPdf(obj: any) {
    if (obj?.qitsd_attachment.includes('data:application/pdf;base64')) {
      const link = document.createElement('a');
      link.href = obj?.qitsd_attachment;
      link.download = `TemplateReport-${this.editCaseData.cas_case_number}.pdf`;
      link.click();
    } else {
      let attachment = obj?.qitsd_attachment.split('<img');
      let qitsd_attachment =
        attachment[0] +
        `<img ${attachment[1]}` +
        (attachment[2]
          ? `<img style="width: 50rem; height: 12rem"' + ${attachment[2]}`
          : '');
      let html = htmlToPdfmake(qitsd_attachment);
      const margin = [20, 20, 20, 20]; // Left, Top, Right, Bottom margins in mm

      const documentDefinition: any = {
        pageOrientation: 'portrait', // or 'landscape' if needed
        pageMargins: margin,
        pageSize: {
          width: 700,
          height: 800,
        },
        content: html,
      };

      const pdfDoc = pdfMake.createPdf(documentDefinition);
      pdfDoc.download(
        `TemplateReport-${this.editCaseData.cas_case_number}.pdf`
      );
    }
  }

  async SendEmail() {
    if (this.checkedList.length > 0) {
      this.sendEmailLoader = true;
      this.showsharedProgressSpinner = true;
      let emails: any = [];
      this.checkedList.forEach((element: any, index: any) => {
        emails[index] = element.email;
      });
      let usersEmail = emails.join();
      let obj = {
        templateData_to: usersEmail,
        templateData_qitsd_created_by: this.helperService.decryption(
          localStorage.getItem(LocalStorage.UId)
        ),
        templateData_qitsd_created_by_name: this.helperService.decryption(
          localStorage.getItem(LocalStorage.UName)
        ),
        templateData_selected_facility: this.editCaseData.facilityName,
        templateData: btoa(
          unescape(encodeURIComponent(this.caseReviewTemplate))
        ),
        case_number: this.editCaseData.cas_case_number,
      };
      this.analyzeService.SendEmailRCAFacility(obj).subscribe({
        next: (res: any) => {
          if (res.msg == 'Success') {
            this.toastrNotificaion.customSuccess('Email Sent Successfully');
            this.reportPageBool = false;
            this.displayModal = false;
            this.sendEmailLoader = false;
            this.showsharedProgressSpinner = false;
          }
        },
      });
    } else {
      this.messageService.add({
        key: 'emailErr',
        severity: 'error',
        detail: `Please select at least one of the following.`,
      });
    }
  }

  loadfacilityMailData(event: any) {
    if (event != undefined && this.selectedOptionText == true) {
      this.take = event.rows;
      this.pageNumber = event.first / this.take + 1;
      this.skip = this.take * this.pageNumber - this.take;
      this.sortOrder =
        event.multiSortMeta == undefined || event.multiSortMeta[0].order == 1
          ? 'ASC'
          : 'DESC';
      this.sortCol =
        event.multiSortMeta == undefined ? '' : event.multiSortMeta[0].field;
      this.filterVal =
        event.filters.global == undefined ? '' : event.filters.global.value;
      this.GetEmaiRcaFacility('');
    }
  }

  checkUncheckAll() {
    for (var i = 0; i < this.shareImprove.length; i++) {
      this.shareImprove[i].isSelected = this.masterSelected;
    }

    this.getCheckedItemList();
  }

  isAllSelected() {
    this.masterSelected = this.shareImprove.every(function (item: any) {
      return item.isSelected == true;
    });
    this.getCheckedItemList();
  }

  getCheckedItemList() {
    this.checkedList = [];
    for (var i = 0; i < this.shareImprove.length; i++) {
      if (this.shareImprove[i].isSelected)
        this.checkedList.push(this.shareImprove[i]);
    }
    this.checkedList = this.checkedList;
  }

  ngOnDestroy() {
    if (this.subscription.length != 0) {
      this.subscription.forEach((i: any) => {
        i.unsubscribe();
      });
    }
    Object.getOwnPropertyNames(this)
      .filter((propName) => Array.isArray((<any>this)[propName]))
      .forEach((propName) => ((<any>this)[propName] = []));
  }
}
